import React, { useCallback, useEffect, useState } from "react";
import {
  getCricketEventDetailsAPI,
  getCricketOddsByMatchIdAPI,
  getMatchDetailsCricketAPI,
  placeCricketBetAPI,
  placeFancyCricketBetAPI,
} from "../service/cricket";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  casinoPL,
  cricketBookMakerPL,
  cricketFancy1PL,
  cricketFancyPL,
  cricketMatchOddsPL,
} from "../utils/profitLoss";
import { applyFancyFor, getProfit } from "../utils/constants";
import toast from "react-hot-toast";
import BetSlip from "../components/BetSlip";
import Loader from "../components/Loader";
import Modal from "../components/Modal";
import RuleSports from "../components/RuleSports";
import moment from "moment";
import { getLiveStreamingUrlAPI } from "../service/AuthService";
import BookModal from "../components/BookModal";

export default function CricketBet() {
  const { id } = useParams();
  const [odds, setOddQuery] = useState({});
  const [activeGameType, setActiveGameType] = useState("normal");
  const [bookModalOpen, setBookModalOpen] = useState(null);
  const [game, setGame] = useState("cricket");
  const [loading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.account.userData);
  const dispatch = useDispatch();
  const [exposure, setExposure] = React.useState({});
  const [selectedMode,setSelectedMode] = useState("fancy")
  const [eventExposureAndSettings, setEventExposureAndSettings] =
    React.useState();
  const getEventExposureAndSettings = useCallback(async () => {
    const { response, code } = await getMatchDetailsCricketAPI(id);
    if (code === 200) {
      setEventExposureAndSettings(response);
    }
  }, [id]);
  const [modalContent, setModalContent] = useState(null);
  const [selectedFancy, setSelectedFancy] = useState("all");
  const [sportBookModalOpen, setSportBookModalOpen] = useState(false);
  const [gameEvent, setGameEvent] = useState({});
  const [selectedMarket, setSelectedMarket] = useState("All");
  const [showTv, setShowTv] = useState(false);
  const selectedEventForBet = useSelector(
    (state) => state.gameData.selectedEventForBet
  );
  const getOdds = async () => {
    const { response, code } = await getCricketOddsByMatchIdAPI(id);
    if (code == 200) {
      setOddQuery(response);
    }
  };
  const getLadderForMarket = (marketId) => {
    return eventExposureAndSettings?.plExposureResponseDTOs?.find(
      (i) => i.marketIdExternal === marketId
    )?.runnerPlExposureDTOS;
  };
  const getGameEventDetails = useCallback(async () => {
    const { response, code } = await getCricketEventDetailsAPI(id);
    if (code === 200) {
      setGameEvent(response);
    }
  }, [id, userData?.token]);

  const getCricketMatchDetails = useCallback(async () => {
    const { response } = await getMatchDetailsCricketAPI(id);

    dispatch({
      type: "gameData/setMatchSettings",
      payload: {
        game,
        settings: response,
        eventId: id,
      },
    });
  }, [dispatch, game, id]);
  useEffect(() => {
    setIsLoading(true);
    getGameEventDetails();
     setIsLoading(false);
    if (userData.token) {
      getGameEventDetails();
      getCricketMatchDetails();
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      let interval = setInterval(() => {
        getCricketMatchDetails();
        getEventExposureAndSettings();
      }, 5000);
      return () => clearInterval(interval);
    }
   
  }, [game, userData.token]);
  var gameSettings = useSelector((state) => state.gameData["cricketSettings"]);
  if (gameSettings && gameSettings[id]) {
    gameSettings = gameSettings[id];
  }

  const getExposure = (match, isFancy = true) => {
    let exposure_;
    gameSettings?.plExposureResponseDTOs?.map((item) => {
      if (isFancy) {
        if (item?.marketIdExternal == match?.marketId) {
          exposure_ = item?.exposure;
        }
      }
    });

    return exposure_;
  };

  const setSelectedEventForBet = (data) => {
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: data,
    });
  };
  useEffect(() => {
    getOdds();

    let interval = setInterval(() => {
      getOdds();
    }, 800);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (selectedEventForBet?.amount) {
      setSelectedEventForBet({
        ...selectedEventForBet,
        profit: getProfit(0, game, selectedEventForBet).profit,
        loss: getProfit(0, game, selectedEventForBet).loss,
      });
    }
  }, [selectedEventForBet?.amount]);
  const applyBlinkEffect = (element, type) => {
    element?.classList?.add("Spark" + type);
    setTimeout(() => {
      element?.classList?.remove("Spark" + type);
    }, 1000);
  };
  useEffect(() => {
    const observers = [];

    const intervalId = setInterval(() => {
      const layButtons = document.querySelectorAll(".match-inn-txt-top");
      if (layButtons.length > 0) {
        clearInterval(intervalId);
        layButtons.forEach((layButton) => {
          const observer = new MutationObserver(() => {
            applyBlinkEffect(layButton.parentElement, "Back");
          });
          observer.observe(layButton, {
            childList: true,
            subtree: true,
            characterData: true,
          });

          observers.push(observer);
        });
      }
      const buttons = document.querySelectorAll(".match-inn-txt-btm");
      if (buttons.length > 0) {
        clearInterval(intervalId);
        buttons.forEach((layButton) => {
          const observer = new MutationObserver(() => {
            applyBlinkEffect(buttons.parentElement, "Back");
          });
          observer.observe(layButton, {
            childList: true,
            subtree: true,
            characterData: true,
          });

          observers.push(observer);
        });
      }
      //match-inn-txt-btm
    }, 1000); // Check every 1 second

    return () => {
      // Cleanup: clear interval and disconnect observers
      clearInterval(intervalId);
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  const getPandL = (data, match) => {
    let pandl = null;
    if (data.selectionId == selectedEventForBet?.selectedId) {
      if (selectedEventForBet?.type == "back") {
        pandl =
          parseInt(selectedEventForBet?.profit) +
          (parseInt(exposure?.exposure) ? exposure.exposure : 0);
      } else {
        pandl =
          (parseInt(exposure?.exposure) ? exposure.exposure : 0) -
          parseInt(selectedEventForBet?.loss);
      }
    }
    if (data.selectionId != selectedEventForBet?.selectedId) {
      if (selectedEventForBet?.type == "lay") {
        pandl =
          parseInt(selectedEventForBet?.profit) +
          (parseInt(exposure?.exposure) ? exposure.exposure : 0);
      } else {
        pandl =
          (parseInt(exposure?.exposure) ? exposure.exposure : 0) -
          parseInt(selectedEventForBet?.loss);
      }
    }
    if (pandl == null || pandl == undefined) {
      return "";
    } else if (isNaN(pandl)) {
      return "";
    } else {
      return pandl?.toFixed(2);
    }
  };
  const [showScore, setShowScore] = useState(true);
  const fancySetBet = (data, type, market, gameType) => {
    let matchData = odds?.fancyOdds?.find(
      (item) => item?.gameType?.toLowerCase() == gameType?.toLowerCase()
    );
    console.log(matchData);
    if (!matchData) return;
    let amount = selectedEventForBet?.amount ? selectedEventForBet?.amount : 0;

    let selectedEventForBet_ = {
      eventId: id,

      marketId: data?.marketId,
      marketType: market,
      marketName: matchData?.marketName,
      type: type?.startsWith("lay") ? "lay" : "back",
      isBookmaker: false,
      selectedRate: data[type?.startsWith("lay") ? "laySize1" : "backSize1"],
      selectedOdd: data[type],
      selectedId: data.selectionId,

      amount: amount,
      runnerName: data.runnerName,
      isYesAndNo: true,
      isFancy: true,
      gameType: gameType,
      isCashout: false,
    };

    if (selectedFancy?.toLowerCase() == "fancy1" || gameType == "fancy1") {
      selectedEventForBet_.gameType = "fancy1";
      selectedEventForBet_["selectedRate"] = data[type];
      selectedEventForBet_.profit = cricketMatchOddsPL(
        data[type],
        0,
        selectedEventForBet_.type
      ).profit;

      selectedEventForBet_.loss = cricketMatchOddsPL(
        data[type],
        0,
        selectedEventForBet_.type
      ).loss;
    }
    if (selectedEventForBet_?.selectedOdd == 0) {
      return;
    }
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: selectedEventForBet_,
    });
    selectedEventForBet_ = {
      ...selectedEventForBet_,
      profit: getProfit(0, game, selectedEventForBet_).profit,
      loss: getProfit(0, game, selectedEventForBet_).loss,
    };
  };
  const amountFormatter = (amount) => {
    if (amount > 10000000) {
      return (amount / 10000000).toFixed(2) + "Cr";
    } else if (amount > 100000) {
      return (amount / 100000).toFixed(2) + "M";
    } else if (amount > 1000) {
      return (amount / 1000).toFixed(2) + "K";
    } else {
      return amount;
    }
  };
  const bookmakerSetBet = (data, type, market, gameType = "bookmaker") => {
    let matchData = odds.bookMakerOdds[0]?.bm1;
    if (gameType != "bookmaker" && market == "MATCH_ODDS") {
      matchData = odds?.matchOdds[0];
    } else if (market == "MATCH_ODDS") {
      matchData = odds?.matchOdds[0];
    } else if (market == "BOOKMAKER_ODDS_1") {
      matchData = odds?.bookMakerOdds[0];
    } else if (market == "OTHER_MARKET" || market == "TIED_MATCH") {
      matchData = odds?.otherMarketOdds?.find(
        (item) => item?.marketName == market
      );
    }

    if (!matchData) return;

    let selectedEventForBet_ = {
      eventId: id,
      amount: selectedEventForBet?.amount ? selectedEventForBet?.amount : 0,
      marketId: matchData?.marketId,
      marketType: market,
      marketName:
        market == "TIED_MATCH" || market == "OTHER_MARKET"
          ? matchData?.market
          : matchData?.marketName,
      type: type?.startsWith("lay") ? "lay" : "back",
      isBookmaker: gameType == "bookmaker",
      selectedRate: data[type?.startsWith("lay") ? "laySize1" : "backSize1"],
      selectedOdd: data[type],
      selectedId: data.selectionId,

      runnerName: data.runnerName,
      isYesAndNo: false,
      isCashout: false,
    };
    if (selectedEventForBet_?.selectedOdd == 0) {
      return;
    }
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: selectedEventForBet_,
    });
    selectedEventForBet_ = {
      ...selectedEventForBet_,
      profit: getProfit(0, game, selectedEventForBet_).profit,
      loss: getProfit(0, game, selectedEventForBet_).loss,
    };
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: selectedEventForBet_,
    });
  };
  const placeBet = async () => {
    if (!userData.token) {
      toast.error("Please Login to Place Bet");
      return;
    }
    setIsLoading(true);
    let delay = 0;
    let selectedAmount_ = selectedEventForBet?.amount;
    if (selectedEventForBet.selectedOdd <= 0) {
      toast.error("Please select a Valid Odd");
      setIsLoading(false);
      return;
    }

    if (game == "cricket" || game == "tennis" || game == "soccer") {
      if (
        (selectedEventForBet.marketName == "MATCH_ODDS" &&
          gameSettings?.minStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "BOOKMAKER_ODDS_2" &&
          gameSettings?.minStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS" &&
          gameSettings?.sessionMinStack > selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS_2" &&
          gameSettings?.sessionMinStack > selectedAmount_)
      ) {
        toast.error(
          `Minimum bet amount is ${
            selectedEventForBet.marketName == "FANCY_ODDS_2"
              ? gameSettings?.sessionMinStack
              : selectedEventForBet.marketName == "FANCY_ODDS"
              ? gameSettings?.sessionMinStack
              : selectedEventForBet.marketName == "BOOKMAKER_ODDS_2"
              ? gameSettings?.bookmakerMinStack
              : gameSettings?.minStack
          }`
        );
        setIsLoading(false);
        return;
      }
      if (
        (selectedEventForBet.marketName == "MATCH_ODDS" &&
          gameSettings?.maxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "BOOKMAKER_ODDS_2" &&
          gameSettings?.bookmakerMaxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS" &&
          gameSettings?.sessionMaxStack < selectedAmount_) ||
        (selectedEventForBet.marketName == "FANCY_ODDS_2" &&
          gameSettings?.sessionMaxStack < selectedAmount_)
      ) {
        toast.error(
          `Maximum bet amount is ${
            selectedEventForBet.marketName == "FANCY_ODDS_2"
              ? gameSettings?.sessionMaxStack
              : selectedEventForBet.marketName == "FANCY_ODDS"
              ? gameSettings?.sessionMaxStack
              : selectedEventForBet.marketName == "BOOKMAKER_ODDS_2"
              ? gameSettings?.bookmakerMaxStack
              : gameSettings?.maxStack
          }`
        );
        setIsLoading(false);
        return;
      }
    }
    if (selectedEventForBet?.isFancy) {
      delay = 0;
    }
    let profit;
    let loss;
    if (game == "cricket" && selectedEventForBet.isBookmaker) {
      profit = cricketBookMakerPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).profit;
      loss = cricketBookMakerPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).loss;
    } else if (game == "tennis" || game == "soccer") {
      profit = casinoPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).profit;
      loss = casinoPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).loss;
    } else {
      profit = cricketMatchOddsPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).profit;
      loss = cricketMatchOddsPL(
        selectedEventForBet.selectedOdd,
        selectedAmount_,
        selectedEventForBet.type
      ).loss;
    }
    let payload = {
      amount: selectedAmount_,
      profit: parseFloat(profit).toFixed(2),
      loss: parseFloat(loss).toFixed(2),
      marketId: selectedEventForBet.marketId,
      selectionId: selectedEventForBet.selectedId,
      type: selectedEventForBet.type,
      eventId: parseInt(selectedEventForBet.eventId),
      runnerName: selectedEventForBet.runnerName,
      gameType:
        selectedEventForBet.marketName != "MATCH_ODDS" ||
        selectedEventForBet.marketName != "BOOKMAKER_ODDS_1" ||
        selectedEventForBet.marketName != "BOOKMAKER_ODDS_2"
          ? selectedEventForBet.gameType
          : selectedEventForBet.marketName,
      marketName: selectedEventForBet.marketName,
    };
    if (selectedEventForBet.isBookmaker && selectedEventForBet?.layRate) {
      payload["layRate"] = selectedEventForBet.selectedOdd;
    } else if (
      selectedEventForBet?.isBookmaker &&
      selectedEventForBet?.backRate
    ) {
      payload["backRate"] = selectedEventForBet.selectedOdd;
    }

    if (selectedEventForBet.type == "back") {
      payload["back"] = parseFloat(selectedEventForBet.selectedOdd);
      payload["backRate"] = parseFloat(selectedEventForBet.selectedOdd);
    } else {
      payload["layRate"] = parseFloat(selectedEventForBet.selectedOdd);
      payload["lay"] = parseFloat(selectedEventForBet.selectedOdd);
    }

    await new Promise((resolve) => setTimeout(resolve, delay));

    if (game == "cricket" && !selectedEventForBet.isFancy) {
      const { response, code, data } = await placeCricketBetAPI(
        payload,
        userData.token
      );
      if (code == 200) {
        toast.success("Bet Placed");
      } else if (code == 500) {
        toast.error(response);
      } else if (code == "ERR_BAD_RESPONSE") {
        toast.error("Something Went Wrong");
      } else {
        toast.error("Something Went Wrong");
      }
    } else if (game == "cricket" && selectedEventForBet?.isFancy) {
      let fancyPayload = {
        amount: selectedAmount_,
        eventId: parseInt(selectedEventForBet.eventId),
        marketId: selectedEventForBet.marketId,
        marketName:
          selectedEventForBet.marketName != "MATCH_ODDS" ||
          selectedEventForBet.marketName != "BOOKMAKER_ODDS_1" ||
          selectedEventForBet.marketName != "BOOKMAKER_ODDS_2"
            ? selectedEventForBet.gameType
            : selectedEventForBet.marketName,
        gameType: selectedEventForBet.gameType,
      };

      if (selectedEventForBet.type === "lay") {
        fancyPayload["layRate"] = selectedEventForBet.selectedRate;
        fancyPayload.oddsLay = selectedEventForBet.selectedOdd;
        if (selectedEventForBet.gameType == "fancy1") {
          fancyPayload["layRate"] = selectedEventForBet.selectedOdd;
          fancyPayload.oddsLay = selectedEventForBet.selectedOdd;
        }
      } else {
        fancyPayload["backRate"] = selectedEventForBet.selectedRate;
        fancyPayload.oddsBack = selectedEventForBet.selectedOdd;
        if (selectedEventForBet.gameType == "fancy1") {
          fancyPayload["backRate"] = selectedEventForBet.selectedOdd;
          fancyPayload.oddsBack = selectedEventForBet.selectedOdd;
        }
      }

      if (
        applyFancyFor.find(
          (item) =>
            item?.toLowerCase() == selectedEventForBet?.gameType?.toLowerCase()
        )
      ) {
        if (selectedEventForBet?.type == "lay") {
          console.log(selectedEventForBet?.gameType);
          if (selectedEventForBet?.gameType == "fancy1") {
            fancyPayload.profit = cricketFancy1PL(
              selectedEventForBet.selectedOdd,
              selectedAmount_,
              selectedEventForBet.type
            ).loss;
            fancyPayload.loss = cricketFancy1PL(
              selectedEventForBet.selectedOdd,
              selectedAmount_,
              selectedEventForBet.type
            ).profit;
          } else {
            fancyPayload.profit = cricketFancyPL(
              selectedEventForBet.selectedRate,
              selectedAmount_,
              selectedEventForBet.type
            ).loss;
            fancyPayload.loss = cricketFancyPL(
              selectedEventForBet.selectedRate,
              selectedAmount_,
              selectedEventForBet.type
            ).profit;
          }
        } else {
          if (selectedEventForBet?.gameType == "fancy1") {
            fancyPayload.profit = cricketMatchOddsPL(
              selectedEventForBet.selectedOdd,
              selectedAmount_,
              selectedEventForBet.type
            ).profit;
            fancyPayload.loss = cricketMatchOddsPL(
              selectedEventForBet.selectedOdd,
              selectedAmount_,
              selectedEventForBet.type
            ).loss;
          } else {
            fancyPayload.profit = cricketFancyPL(
              selectedEventForBet.selectedRate,
              selectedAmount_,
              selectedEventForBet.type
            ).profit;
            fancyPayload.loss = cricketFancyPL(
              selectedEventForBet.selectedRate,
              selectedAmount_,
              selectedEventForBet.type
            ).loss;
          }
        }
      } else {
        fancyPayload.profit = cricketMatchOddsPL(
          selectedEventForBet.selectedOdd,
          selectedAmount_,
          selectedEventForBet.type
        ).profit;
        fancyPayload.loss = cricketMatchOddsPL(
          selectedEventForBet.selectedOdd,
          selectedAmount_,
          selectedEventForBet.type
        ).loss;
        fancyPayload.selectionId = selectedEventForBet.selectedId;
        fancyPayload.runnerName = selectedEventForBet.runnerName;
        if (selectedEventForBet.type === "lay") {
          fancyPayload["layRate"] = selectedEventForBet.selectedOdd;
        } else {
          fancyPayload["backRate"] = selectedEventForBet.selectedOdd;
        }
      }

      const { response, code, data } = await placeFancyCricketBetAPI(
        fancyPayload,
        userData.token
      );
      if (code == 200) {
        toast.success("Bet Placed successfully");
        setIsLoading(false);

        await getCricketMatchDetails();
        await getEventExposureAndSettings();
        dispatch({
          type: "gameData/setSelectedEventForBet",
          payload: null,
        });
      } else if (code == 500) {
        toast.error(response);
      } else if (code == "ERR_BAD_RESPONSE") {
        setIsLoading(false);
        toast.error("Something Went wrong");
      } else {
        toast.error("Something Went Wrong");
      }
    }
    setIsLoading(false);
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: null,
    });
  };
  const handleCashoutClick = (
    marketIdExternal,
    marketType = "matchOdds",
    sports = "cricket"
  ) => {
    const plExposures = [];

    for (let i = 0; i < gameSettings?.plExposureResponseDTOs.length; i++) {
      if (
        gameSettings?.plExposureResponseDTOs[i].marketIdExternal ===
        marketIdExternal
      ) {
        for (
          let j = 0;
          j <
          gameSettings?.plExposureResponseDTOs[i].runnerPlExposureDTOS.length;
          j++
        ) {
          plExposures.push(
            gameSettings?.plExposureResponseDTOs[i].runnerPlExposureDTOS[j]
          );
        }
      }
    }

    plExposures.sort((a, b) => b.exposure - a.exposure);

    var odds_ = [];
    if (sports == "cricket") {
      let marketData =
        marketType == "bookMakerOdds"
          ? odds[marketType][0]?.bm1
          : odds[marketType][0];
      for (let i = 0; i < marketData.oddDetailsDTOS.length; i++) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId == marketData.oddDetailsDTOS[i].selectionId
          )
        ) {
          odds_.push({
            ...marketData.oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId == marketData.oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    } else {
      for (
        let i = 0;
        i < odds?.matchOddsResponseDTO[0].oddDetailsDTOS.length;
        i++
      ) {
        if (
          plExposures.find(
            (item) =>
              item.selectionId ==
              odds?.matchOddsResponseDTO[0].oddDetailsDTOS[i].selectionId
          )
        ) {
          odds_.push({
            ...odds?.matchOddsResponseDTO[0].oddDetailsDTOS[i],
            exposure: plExposures.find(
              (item) =>
                item.selectionId ==
                odds?.matchOddsResponseDTO[0].oddDetailsDTOS[i].selectionId
            ).exposure,
          });
        }
      }
    }
    odds_.sort((a, b) => b.exposure - a.exposure);
    var oppositeTeam = {
      back1: parseFloat(odds_[1]?.back1),
      back2: parseFloat(odds_[1]?.back2),
      back3: parseFloat(odds_[1]?.back3),
      backSize1: parseFloat(odds_[1]?.backSize1),
      backSize2: parseFloat(odds_[1]?.backSize2),
      backSize3: parseFloat(odds_[1]?.backSize3),
      lay1: parseFloat(odds_[1]?.lay1),
      lay2: parseFloat(odds_[1]?.lay2),
      lay3: parseFloat(odds_[1]?.lay3),
      laySize1: parseFloat(odds_[1]?.laySize1),
      laySize2: parseFloat(odds_[1]?.laySize2),
      laySize3: parseFloat(odds_[1]?.laySize3),
      exposure: odds_[1]?.exposure,
      runnerName: odds_[1]?.runnerName,
    };
    var sameTeam = {
      back1: parseFloat(odds_[0]?.back1),
      back2: parseFloat(odds_[0]?.back2),
      back3: parseFloat(odds_[0]?.back3),
      backSize1: parseFloat(odds_[0]?.backSize1),
      backSize2: parseFloat(odds_[0]?.backSize2),
      backSize3: parseFloat(odds_[0]?.backSize3),
      lay1: parseFloat(odds_[0]?.lay1),
      lay2: parseFloat(odds_[0]?.lay2),
      lay3: parseFloat(odds_[0]?.lay3),
      laySize1: parseFloat(odds_[0]?.laySize1),
      laySize2: parseFloat(odds_[0]?.laySize2),
      laySize3: parseFloat(odds_[0]?.laySize3),
      exposure: odds_[0]?.exposure,
      runnerName: odds_[0]?.runnerName,
    };
    var calculationMap = {
      pandl: -Infinity,
      amount: 0,
      oddDecided: 0,
      type: "back",
      oddRate: 0,
    };
    function calculatePandL(oddType, OddSize) {
      if (oddType == "back1" || oddType == "back2" || oddType == "back3") {
        var pandlInternal =
          (oppositeTeam.exposure +
            oppositeTeam[oddType] * sameTeam.exposure -
            sameTeam.exposure) /
          oppositeTeam.oddType;
        var amountInternal = sameTeam.exposure - pandlInternal;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = oppositeTeam[oddType];
          calculationMap.type = "back";
          calculationMap.oddRate = oppositeTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      } else {
        var pandlInternal =
          (sameTeam.exposure +
            sameTeam[oddType] * oppositeTeam.exposure -
            oppositeTeam.exposure) /
          sameTeam[oddType];
        var amountInternal = pandlInternal - oppositeTeam.exposure;
        if (calculationMap.pandl < pandlInternal && amountInternal > 0) {
          calculationMap.pandl = pandlInternal;
          calculationMap.amount = amountInternal;
          calculationMap.oddDecided = sameTeam[oddType];
          calculationMap.type = "lay";
          calculationMap.oddRate = sameTeam[OddSize];
          calculationMap.runnerName = sameTeam.runnerName;
        }
      }
    }

    if (
      sameTeam?.back2 == 0 ||
      sameTeam?.lay2 == 0 ||
      sameTeam?.back3 == 0 ||
      (sameTeam?.lay3 == 0 && oppositeTeam?.back2 == 0) ||
      oppositeTeam?.lay2 == 0 ||
      oppositeTeam?.back3 == 0 ||
      oppositeTeam?.lay3 == 0
    ) {
      calculatePandL("back1", "backSize1");
      calculatePandL("lay1", "laySize1");
    } else {
      calculatePandL("back1", "backSize1");
      calculatePandL("back2", "backSize2");
      calculatePandL("back3", "backSize3");
      calculatePandL("lay1", "laySize1");
      calculatePandL("lay2", "laySize2");
      calculatePandL("lay3", "laySize3");
    }

    if (calculationMap.pandl == -Infinity) {
      toast.error("You are not eligible for cashout");
      return;
    } else if (calculationMap.pandl == Infinity) {
      toast.success("You are not eligible for cashout");
      return;
    }

    setSelectedEventForBet(
      {
        selectedOdd: calculationMap.oddDecided,
        selectedRate: calculationMap.oddRate,
        amount: parseFloat(calculationMap.amount).toFixed(2),
        isBookmaker: false,
        eventId: id,
        marketId: marketIdExternal,
        runnerName: calculationMap.runnerName,
        selectedId: odds_[0]?.selectionId,
        marketName:
          game == "cricket"
            ? marketType == "bookMakerOdds"
              ? odds[marketType][0]?.bm1?.marketName
              : odds[marketType][0]?.marketName
            : odds?.matchOddsResponseDTO[0]?.marketName,
        marketType,
        sports,
        isCashout: true,
        type: calculationMap.type,
      },
      true
    );
  };
  const [channelId, setChannelId] = useState();
  const getLiveStreamingUrl = async () => {
    const { response } = await getLiveStreamingUrlAPI(gameEvent?.eventId);
    setChannelId(response);
  };
  useEffect(() => {
    getLiveStreamingUrl();
    if (userData.token) getEventExposureAndSettings();
  }, [gameEvent?.eventId]);
  const getTossMarket = () => {
    let market = odds?.fancyOdds?.find((item) => item?.gameType == "fancy1");
    if (!market) return [];
    let odds_ = market?.oddDetailsDTOS?.filter((item) =>
      item.runnerName.toLowerCase().includes("toss")
    );
    return odds_;
  };
  useEffect(() => {
    setSelectedEventForBet(null);
  }, [id]);
  return (
    <app-market-details
      style={{
        display: "block",
        paddingBottom: "100px",
      }}
      _nghost-ng-c1546520345=""
    >
      {loading && <Loader />}
      <div _ngcontent-ng-c1546520345="" className="game-highlight-wrap">
        <span
          _ngcontent-ng-c1546520345=""
          className="cric-txt ng-star-inserted"
        >
          Cricket
        </span>

        {userData?.token && (
          <>
            <span
              onClick={() => setShowTv(!showTv)}
              _ngcontent-ng-c1546520345=""
              _ngcontent-dsh-c3=""
              style={{
                float: "right",
                fontWeight: "bold",
                marginRight: 16,
                fontSize: 16,
              }}
            >
              <i
                _ngcontent-ng-c1546520345=""
                _ngcontent-dsh-c3=""
                className="fa fa-television"
              />
            </span>
            <span
              onClick={() => setShowScore(!showScore)}
              _ngcontent-ng-c1546520345=""
              _ngcontent-dsh-c3=""
              style={{
                float: "right",
                fontWeight: "bold",
                marginRight: 16,
                fontSize: 16,
              }}
            >
              <i
                _ngcontent-ng-c1546520345=""
                _ngcontent-dsh-c3=""
                className="fa fa-trophy"
              />
            </span>
          </>
        )}
      </div>

      {/**/}
      <div
        _ngcontent-ng-c1546520345=""
        className="card-body p-0 mb-1 mobile-stream time"
      >
        {showTv && userData?.token && (
          <iframe
            style={{
              width: "100%",
              height: "216px",
              marginBottom: -5,
            }}
            src={`https://video.proexch.in/tv/v4/stream/${channelId}`}
          />
        )}
        {showScore && userData?.token && (
          <>
            <iframe
              style={{
                width: "100%",
                height: "auto",
              }}
              src={`https://scorecardpanel.netlify.app/iframe?eventId=${gameEvent?.eventId}`}
            />
          </>
        )}

        {!showTv && (
          <div
            _ngcontent-ng-c1546520345=""
            className="container-main-time time-cricket-banner"
          >
            <div
              _ngcontent-ng-c1546520345=""
              className="d-flex flex-column justify-content-between align-items-center p-3 pt-2"
              style={{ height: 100 }}
            >
              <div
                _ngcontent-ng-c1546520345=""
                className="d-flex justify-content-between w-100"
              >
                <div _ngcontent-ng-c1546520345="" className="gameStatus">
                  {" "}
                  OPEN{" "}
                </div>
                <div _ngcontent-ng-c1546520345="" className="gameRemainingTime">
                  <span
                    _ngcontent-ng-c1546520345=""
                    className="betStart"
                    style={{ color: "#ff5" }}
                  >
                    {" "}
                    Game time{" "}
                  </span>{" "}
                  {moment(gameEvent?.eventTime).format("DD-MM-YYYY hh:mm A")}
                </div>
              </div>
              <div
                _ngcontent-ng-c1546520345=""
                className="d-flex justify-content-center align-items-center flex-column"
              >
                {/**/}
                {/**/}
                {/**/}
                {/**/}
                <span
                  _ngcontent-ng-c1546520345=""
                  className="betStart in_play_betStarted"
                  style={{ color: "rgb(255, 255, 255)", fontWeight: "bold" }}
                >
                  {" "}
                  Bet Started{" "}
                </span>
                {/**/}
              </div>
              {/**/}
              {/**/}
            </div>
          </div>
        )}
        {/**/}
        {/**/}
      </div>

      <div _ngcontent-ng-c1546520345="" className="desktopView">
        {/**/}
      </div>
      {/*  <iframe src="https://score.proexch.in/#/score1/28947946"/> */}
      <div _ngcontent-ng-c1546520345="" className="marketDetailsList-con">
        <ul _ngcontent-ng-c1546520345="" className="marketDetailsList">
          <li _ngcontent-ng-c1546520345="" className="marketDetailsListItem">
            <a
              onClick={() => setSelectedMarket("All")}
              _ngcontent-ng-c1546520345=""
              className={selectedMarket?.toLowerCase() == "all" && "active"}
            >
              All
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Popular")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={selectedMarket?.toLowerCase() == "popular" && "active"}
            >
              Popular
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Matchodds")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem menu-item"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={
                selectedMarket?.toLowerCase() == "matchodds" && "active"
              }
            >
              Match Odds
            </a>
          </li>
          <li
            onClick={() => setSelectedMarket("Bookmaker")}
            _ngcontent-ng-c1546520345=""
            className="marketDetailsListItem menu-item"
          >
            <a
              _ngcontent-ng-c1546520345=""
              className={
                selectedMarket?.toLowerCase() == "bookmaker" && "active"
              }
            >
              Bookmaker
            </a>
          </li>
          {/**/}
        </ul>
      </div>
      <div _ngcontent-ng-c1546520345="">
        {(selectedMarket?.toLowerCase() == "matchodds" ||
          selectedMarket?.toLowerCase() == "all") &&
          odds &&
          odds.matchOdds &&
          odds.matchOdds.length > 0 && (
            <div
              _ngcontent-ng-c1546520345=""
              className="card matchodd matchodd-cont"
            >
              <div
                _ngcontent-ng-c1546520345=""
                className="card-matchodds outer-divs"
              >
                <strong
                  _ngcontent-ng-c1546520345=""
                  className="match-odds outer-div1"
                >
                  Match Odds{" "}
                  <span
                    _ngcontent-ng-c1546520345=""
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal1"
                    className="marketinfo ml-2"
                  >
                    <svg
                      _ngcontent-ng-c1546520345=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      height={15}
                      viewBox="0 0 15 15"
                    >
                      <path
                        _ngcontent-ng-c1546520345=""
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                      />
                    </svg>
                  </span>
                </strong>
                {selectedEventForBet &&
                selectedEventForBet?.isCashout &&
                selectedEventForBet?.marketName ==
                  odds?.matchOdds[0]?.marketName ? (
                  <div
                    _ngcontent-ng-c1546520345=""
                    style={{
                      top: 0,
                    }}
                    className="cashout-container active 40202492993521867 hasProfitLoss ng-star-inserted"
                  >
                    {/**/}
                    <span
                      _ngcontent-ng-c1546520345=""
                      style={{
                        cursor: "pointer",
                        display: "flex",
                      }}
                      className="cashout-label ng-star-inserted"
                    >
                      <span
                        onClick={() => {
                          placeBet();
                        }}
                        _ngcontent-ng-c1546520345=""
                        className="cashout-icon me-1"
                      >
                        <i
                          _ngcontent-ng-c1546520345=""
                          className="fa fa-check"
                        />
                      </span>
                      <strong
                        _ngcontent-ng-c1546520345=""
                        style={{
                          display: "inline-block",
                          paddingRight: 9,
                        }}
                        className={
                          selectedEventForBet?.profit > 0
                            ? "plus-book"
                            : "minus-book"
                        }
                      >
                        {" "}
                        {selectedEventForBet?.profit}
                      </strong>
                    </span>
                    {/**/}
                  </div>
                ) : (
                  <div
                    _ngcontent-ng-c1546520345=""
                    className="cashout-container outer-div2"
                  >
                    <div
                      onClick={() => {
                        handleCashoutClick(
                          odds?.matchOdds[0]?.marketId,
                          "matchOdds",
                          "cricket"
                        );
                      }}
                      _ngcontent-ng-c1546520345=""
                      className="cashout-container empty-container ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        className="cashout-label"
                      >
                        <span
                          _ngcontent-ng-c1546520345=""
                          className="cashout-icon"
                        >
                          <i
                            _ngcontent-ng-c1546520345=""
                            className="fa fa-circle"
                          />
                        </span>
                        Cash Out
                      </span>
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                  </div>
                )}
                <span
                  _ngcontent-ng-c4047091486=""
                  class="matched-count pull-right outer-div4"
                >
                  Matched <strong _ngcontent-ng-c4047091486="">€ 5.1K</strong>
                </span>
                {/**/}
                {/**/}
              </div>
              <div _ngcontent-ng-c1546520345="" className="card-body p-0">
                <div
                  _ngcontent-ng-c1546520345=""
                  className="table-responsive position-relative"
                >
                  {odds?.matchOdds[0]?.marketStatus?.toUpperCase() !=
                    "OPEN" && (
                    <div
                      _ngcontent-ng-c1546520345=""
                      class="suspended unitycss-PipEJ ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        _ngcontent-wdd-c3=""
                        class="stats-text"
                      >
                        {odds?.matchOdds[0]?.marketStatus?.toUpperCase()}{" "}
                      </span>
                    </div>
                  )}
                  <table
                    _ngcontent-ng-c1546520345=""
                    className="table table-hover tbl-bets betfair-tbl p-rltv"
                  >
                    <thead _ngcontent-ng-c1546520345="">
                      <tr>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="showMinMaxMobile show-xs min-max-mobile"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {gameSettings?.minStack}-{gameSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={3}
                          className="hidden-xs boxHide"
                        />
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="back-1 mobileTableHead"
                        >
                          Back
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="lay-1 mobileTableHead"
                        >
                          Lay
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={2}
                          className="min-max-bet boxHide"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {gameSettings?.minStack}-{gameSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                      </tr>
                    </thead>
                    <tbody _ngcontent-ng-c1546520345="">
                      {odds &&
                        odds.matchOdds &&
                        odds.matchOdds.length > 0 &&
                        odds?.matchOdds[0]?.oddDetailsDTOS?.map((item) => (
                          <>
                            {" "}
                            <tr
                              _ngcontent-ng-c1546520345=""
                              className="odd-row "
                              style={{ position: "relative" }}
                            >
                              <td
                                _ngcontent-ng-c1546520345=""
                                className="team-name"
                              >
                                <span
                                  _ngcontent-ng-c1546520345=""
                                  className="title matchodds_runner"
                                >
                                  {" "}
                                  {item?.runnerName}{" "}
                                </span>

                                <span
                                  _ngcontent-ng-c1546520345=""
                                  className="d-flex"
                                >
                                  <span
                                    _ngcontent-ng-c1703479958=""
                                    className={` ${
                                      eventExposureAndSettings?.plExposureResponseDTOs
                                        ?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            odds?.matchOdds[0]?.marketId
                                        )
                                        ?.runnerPlExposureDTOS?.find(
                                          (runner) =>
                                            runner.selectionId ==
                                            item.selectionId
                                        )?.exposure < 0
                                        ? "minus-book"
                                        : "plus-book"
                                    } ng-star-inserted`}
                                  >
                                    {eventExposureAndSettings?.plExposureResponseDTOs
                                      ?.find(
                                        (i) =>
                                          i.marketIdExternal ===
                                          odds?.matchOdds[0]?.marketId
                                      )
                                      ?.runnerPlExposureDTOS?.find(
                                        (runner) =>
                                          runner.selectionId == item.selectionId
                                      )?.exposure != undefined && (
                                      <i
                                        _ngcontent-ng-c1703479958=""
                                        className="fa fa-arrow-right right-arrow-mt"
                                      />
                                    )}{" "}
                                    &nbsp;{" "}
                                    {eventExposureAndSettings?.plExposureResponseDTOs
                                      ?.find(
                                        (i) =>
                                          i.marketIdExternal ===
                                          odds?.matchOdds[0]?.marketId
                                      )
                                      ?.runnerPlExposureDTOS?.find(
                                        (runner) =>
                                          runner.selectionId == item.selectionId
                                      )
                                      ?.exposure?.toFixed(2)}
                                  </span>
                                  {selectedEventForBet &&
                                    selectedEventForBet.marketName ==
                                      odds?.matchOdds[0]?.marketName && (
                                      <span _ngcontent-ng-c1546520345="">
                                        {/**/}
                                        <span
                                          _ngcontent-ng-c1546520345=""
                                          style={{
                                            display: "flex",
                                            padding: 0,
                                          }}
                                          className="ng-star-inserted"
                                        >
                                          <span
                                            _ngcontent-ng-c1546520345=""
                                            className="d-flex plus-book matchodds ng-star-inserted"
                                            style={{ marginRight: 5 }}
                                          >
                                            <span
                                              _ngcontent-ng-c1546520345=""
                                              className={`${
                                               (eventExposureAndSettings?.plExposureResponseDTOs
                                                ?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    odds?.matchOdds[0]?.marketId
                                                )
                                                ?.runnerPlExposureDTOS?.find(
                                                  (runner) =>
                                                    runner.selectionId ==
                                                    item.selectionId
                                                )?.exposure || 0) +
                                                parseFloat(getPandL(item)) > 0
                                                  ? "plus"
                                                  : "minus"
                                              }-book matchodds`}
                                            >
                                              {" "}
                                              &nbsp;(
                                              {(eventExposureAndSettings?.plExposureResponseDTOs
                                                ?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    odds?.matchOdds[0]?.marketId
                                                )
                                                ?.runnerPlExposureDTOS?.find(
                                                  (runner) =>
                                                    runner.selectionId ==
                                                    item.selectionId
                                                )?.exposure || 0) +
                                                parseFloat(getPandL(item))}
                                              )
                                            </span>
                                          </span>
                                          {/**/}
                                          {/**/}
                                        </span>
                                        {/**/}
                                      </span>
                                    )}
                                </span>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-3 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back3
                                    ? "active"
                                    : ""
                                } `}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back3",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back3}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize3}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-2 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back2
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back2",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back2}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize2}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-1 count ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back1
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back1",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back1}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize1}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-1 count ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay1
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className={`lay`}
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay1",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay1}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize1}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-2 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay2
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay2",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="lay"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay2}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize2}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-3 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay3
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="lay"
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay3",
                                      odds?.matchOdds[0]?.marketName,
                                      "match"
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay3}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize3}
                                  </span>
                                </a>
                              </td>
                            </tr>
                            {selectedEventForBet &&
                              selectedEventForBet.selectedId ==
                                item?.selectionId && (
                                <BetSlip
                                  selectedEventForBet={selectedEventForBet}
                                  placeBet={placeBet}
                                  setSelectedEventForBet={
                                    setSelectedEventForBet
                                  }
                                  dispatch={dispatch}
                                />
                              )}
                          </>
                        ))}

                      {/**/}
                      {/**/}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

        {selectedMarket?.toLowerCase() == "all" &&
          odds &&
          odds.otherMarketOdds &&
          odds.otherMarketOdds.length > 0 &&
          odds?.otherMarketOdds?.map((market) => (
            <div
              _ngcontent-ng-c1546520345=""
              className="card matchodd matchodd-cont"
            >
              <div
                _ngcontent-ng-c1546520345=""
                className="card-matchodds outer-divs"
              >
                <strong
                  _ngcontent-ng-c1546520345=""
                  className="match-odds outer-div1"
                >
                  {market?.market}{" "}
                  <span
                    _ngcontent-ng-c1546520345=""
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal1"
                    className="marketinfo ml-2"
                  >
                    <svg
                      _ngcontent-ng-c1546520345=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={15}
                      height={15}
                      viewBox="0 0 15 15"
                    >
                      <path
                        _ngcontent-ng-c1546520345=""
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                      />
                    </svg>
                  </span>
                </strong>
                {selectedEventForBet &&
                selectedEventForBet?.isCashout &&
                selectedEventForBet?.marketName == market?.marketName ? (
                  <div
                    _ngcontent-ng-c1546520345=""
                    style={{
                      top: 0,
                    }}
                    className="cashout-container active 40202492993521867 hasProfitLoss ng-star-inserted"
                  >
                    {/**/}
                    <span
                      _ngcontent-ng-c1546520345=""
                      className="cashout-label ng-star-inserted"
                    >
                      <span
                        onClick={() => {
                          placeBet();
                        }}
                        _ngcontent-ng-c1546520345=""
                        className="cashout-icon me-1"
                      >
                        <i
                          _ngcontent-ng-c1546520345=""
                          className="fa fa-check"
                        />
                      </span>
                      <strong
                        _ngcontent-ng-c1546520345=""
                        style={{
                          display: "inline-block",
                          paddingRight: 9,
                        }}
                        className={
                          selectedEventForBet?.profit > 0
                            ? "plus-book"
                            : "minus-book"
                        }
                      >
                        {" "}
                        {selectedEventForBet?.profit}
                      </strong>
                    </span>
                    {/**/}
                  </div>
                ) : (
                  <div
                    _ngcontent-ng-c1546520345=""
                    className="cashout-container outer-div2"
                  >
                    <div
                      onClick={() => {
                        handleCashoutClick(
                          market?.marketId,
                          "otherMarketOdds",
                          "cricket"
                        );
                      }}
                      _ngcontent-ng-c1546520345=""
                      className="cashout-container empty-container ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        className="cashout-label"
                      >
                        <span
                          _ngcontent-ng-c1546520345=""
                          className="cashout-icon"
                        >
                          <i
                            _ngcontent-ng-c1546520345=""
                            className="fa fa-circle"
                          />
                        </span>
                        Cash Out
                      </span>
                    </div>
                    {/**/}
                    {/**/}
                    {/**/}
                  </div>
                )}
                <span
                  _ngcontent-ng-c4047091486=""
                  class="matched-count pull-right outer-div4"
                >
                  Matched <strong _ngcontent-ng-c4047091486="">€ 1.1K</strong>
                </span>
                {/**/}
                {/**/}
              </div>
              <div _ngcontent-ng-c1546520345="" className="card-body p-0">
                <div
                  _ngcontent-ng-c1546520345=""
                  className="table-responsive position-relative"
                >
                  {market?.marketStatus?.toUpperCase() != "OPEN" && (
                    <div
                      _ngcontent-ng-c1546520345=""
                      class="suspended unitycss-PipEJ ng-star-inserted"
                    >
                      <span
                        _ngcontent-ng-c1546520345=""
                        _ngcontent-wdd-c3=""
                        class="stats-text"
                      >
                        {market?.marketStatus?.toUpperCase()}{" "}
                      </span>
                    </div>
                  )}
                  <table
                    _ngcontent-ng-c1546520345=""
                    className="table table-hover tbl-bets betfair-tbl p-rltv"
                  >
                    <thead _ngcontent-ng-c1546520345="">
                      <tr>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="showMinMaxMobile show-xs min-max-mobile"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {gameSettings?.minStack}-{gameSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={3}
                          className="hidden-xs boxHide"
                        />
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="back-1 mobileTableHead"
                        >
                          Back
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          className="lay-1 mobileTableHead"
                        >
                          Lay
                        </th>
                        <th
                          _ngcontent-ng-c1546520345=""
                          colSpan={2}
                          className="min-max-bet boxHide"
                        >
                          <dl
                            _ngcontent-ng-c1546520345=""
                            id="minMaxBox"
                            className="fancy-info matchoddsminmax"
                          >
                            <dt _ngcontent-ng-c1546520345="">Min/Max</dt>
                            <dd _ngcontent-ng-c1546520345="" id="minMaxInfo">
                              {gameSettings?.minStack}-{gameSettings?.maxStack}
                            </dd>
                          </dl>
                        </th>
                      </tr>
                    </thead>
                    <tbody _ngcontent-ng-c1546520345="">
                      {odds &&
                        odds.otherMarketOdds &&
                        odds.otherMarketOdds.length > 0 &&
                        market?.oddDetailsDTOS?.map((item) => (
                          <>
                            {" "}
                            <tr
                              _ngcontent-ng-c1546520345=""
                              className="odd-row "
                              style={{ position: "relative" }}
                            >
                              <td
                                _ngcontent-ng-c1546520345=""
                                className="team-name"
                              >
                                <span
                                  _ngcontent-ng-c1546520345=""
                                  className="title matchodds_runner"
                                >
                                  {" "}
                                  {item?.runnerName}{" "}
                                </span>
                                <span
                                  _ngcontent-ng-c1546520345=""
                                  className="d-flex"
                                >
                                  <span
                                    style={{
                                      display:
                                        eventExposureAndSettings?.plExposureResponseDTOs
                                          ?.find(
                                            (i) =>
                                              i.marketIdExternal ===
                                              market?.marketId
                                          )
                                          ?.runnerPlExposureDTOS?.find(
                                            (runner) =>
                                              runner.selectionId ==
                                              item.selectionId
                                          )?.exposure == undefined
                                          ? "none !important"
                                          : "flex",
                                    }}
                                    _ngcontent-ng-c1703479958=""
                                    className={` ${
                                      eventExposureAndSettings?.plExposureResponseDTOs
                                        ?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            market?.marketId
                                        )
                                        ?.runnerPlExposureDTOS?.find(
                                          (runner) =>
                                            runner.selectionId ==
                                            item.selectionId
                                        )?.exposure < 0
                                        ? "minus-book"
                                        : "plus-book"
                                    } ng-star-inserted`}
                                  >
                                    {eventExposureAndSettings?.plExposureResponseDTOs
                                      ?.find(
                                        (i) =>
                                          i.marketIdExternal ===
                                          market?.marketId
                                      )
                                      ?.runnerPlExposureDTOS?.find(
                                        (runner) =>
                                          runner.selectionId == item.selectionId
                                      )?.exposure != undefined && (
                                      <i
                                        _ngcontent-ng-c1703479958=""
                                        className="fa fa-arrow-right right-arrow-mt"
                                      />
                                    )}{" "}
                                    &nbsp;{" "}
                                    {
                                      eventExposureAndSettings?.plExposureResponseDTOs
                                        ?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            market?.marketId
                                        )
                                        ?.runnerPlExposureDTOS?.find(
                                          (runner) =>
                                            runner.selectionId ==
                                            item.selectionId
                                        )?.exposure
                                    }
                                  </span>
                                  {selectedEventForBet &&
                                    selectedEventForBet.marketName ==
                                      market?.market && (
                                      <span _ngcontent-ng-c1546520345="">
                                        {/**/}
                                        <span
                                          _ngcontent-ng-c1546520345=""
                                          style={{
                                            display: "flex",
                                            padding: 0,
                                          }}
                                          className="ng-star-inserted"
                                        >
                                          <span
                                            _ngcontent-ng-c1546520345=""
                                            className="d-flex plus-book matchodds ng-star-inserted"
                                            style={{ marginRight: 5 }}
                                          >
                                            <span
                                              _ngcontent-ng-c1546520345=""
                                              className={`${
                                                getPandL(item) > 0
                                                  ? "plus"
                                                  : "minus"
                                              }-book matchodds`}
                                            >
                                              {" "}
                                              &nbsp;({getPandL(item)})
                                            </span>
                                          </span>
                                          {/**/}
                                          {/**/}
                                        </span>
                                        {/**/}
                                      </span>
                                    )}
                                </span>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-3 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back3
                                    ? "active"
                                    : ""
                                } `}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back3",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back3}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize3}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-2 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back2
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back2",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back2}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize2}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`back-1 count ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "back" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.back1
                                    ? "bookmaker"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "back1",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="back"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back1}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.backSize1}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-1 count ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay1
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className={`lay`}
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay1",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-book-inner-data match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay1}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize1}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-2 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay2
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay2",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="lay"
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay2}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize2}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c1546520345=""
                                className={`lay-3 count boxHide ${
                                  selectedEventForBet &&
                                  selectedEventForBet.type == "lay" &&
                                  selectedEventForBet.selectedId ==
                                    item?.selectionId &&
                                  selectedEventForBet.selectedOdd == item?.lay3
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <a
                                  _ngcontent-ng-c1546520345=""
                                  appratehighlighter=""
                                  className="lay"
                                  onClick={() => {
                                    bookmakerSetBet(
                                      item,
                                      "lay3",
                                      market?.marketName,
                                      market?.market
                                    );
                                  }}
                                >
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.lay3}
                                  </span>
                                  <span
                                    _ngcontent-ng-c1546520345=""
                                    className="position-relative match-inn-txt-btm"
                                  >
                                    {item?.laySize3}
                                  </span>
                                </a>
                              </td>
                            </tr>
                            {selectedEventForBet &&
                              selectedEventForBet.selectedId ==
                                item?.selectionId && (
                                <BetSlip
                                  selectedEventForBet={selectedEventForBet}
                                  placeBet={placeBet}
                                  setSelectedEventForBet={
                                    setSelectedEventForBet
                                  }
                                  dispatch={dispatch}
                                />
                              )}
                          </>
                        ))}

                      {/**/}
                      {/**/}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))}

        {(selectedMarket?.toLowerCase() == "bookmaker" ||
          selectedMarket?.toLowerCase() == "all") &&
          odds &&
          odds.bookMakerOdds &&
          odds?.bookMakerOdds?.length > 0 && (
            <div _ngcontent-ng-c1546520345="" className="ipl-winner mt-1">
              <div _ngcontent-ng-c1546520345="" className="flex-wrap">
                <div _ngcontent-ng-c1546520345="">
                  <div
                    _ngcontent-ng-c1546520345=""
                    className="card mb-0 matchodd bookmaker-mobile-custom-css"
                  >
                    <div
                      _ngcontent-ng-c1546520345=""
                      className="card-matchodds outer-divs"
                    >
                      <strong
                        onClick={() => {
                          setModalContent(<RuleSports />);
                        }}
                        _ngcontent-ng-c1546520345=""
                        className="match-odds bookmaker-dark-head"
                      >
                        Bookmaker{" "}
                        <span
                          _ngcontent-ng-c1546520345=""
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal1"
                          className="marketinfo ml-2"
                        >
                          <svg
                            _ngcontent-ng-c1546520345=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                          >
                            <path
                              _ngcontent-ng-c1546520345=""
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                            />
                          </svg>
                        </span>
                      </strong>
                      {selectedEventForBet &&
                      selectedEventForBet?.isCashout &&
                      selectedEventForBet?.marketName ==
                        odds?.bookMakerOdds[0]?.bm1?.marketName ? (
                        <div
                          _ngcontent-ng-c1546520345=""
                          style={{
                            top: 0,
                          }}
                          className="cashout-container active 40202492993521867 hasProfitLoss ng-star-inserted"
                        >
                          {/**/}
                          <span
                            _ngcontent-ng-c1546520345=""
                            className="cashout-label ng-star-inserted"
                          >
                            <span
                              onClick={() => {
                                placeBet();
                              }}
                              _ngcontent-ng-c1546520345=""
                              className="cashout-icon me-1"
                            >
                              <i
                                _ngcontent-ng-c1546520345=""
                                className="fa fa-check"
                              />
                            </span>
                            <strong
                              _ngcontent-ng-c1546520345=""
                              style={{
                                display: "inline-block",
                                paddingRight: 9,
                              }}
                              className={
                                selectedEventForBet?.profit > 0
                                  ? "plus-book"
                                  : "minus-book"
                              }
                            >
                              {" "}
                              {selectedEventForBet?.profit}
                            </strong>
                          </span>
                          {/**/}
                        </div>
                      ) : (
                        <div
                          _ngcontent-ng-c1546520345=""
                          className="cashout-container outer-div2"
                        >
                          <div
                            onClick={() => {
                              handleCashoutClick(
                                odds?.bookMakerOdds[0]?.bm1?.marketId,
                                "bookMakerOdds",
                                "cricket"
                              );
                            }}
                            _ngcontent-ng-c1546520345=""
                            className="cashout-container empty-container ng-star-inserted"
                          >
                            <span
                              _ngcontent-ng-c1546520345=""
                              className="cashout-label"
                            >
                              <span
                                _ngcontent-ng-c1546520345=""
                                className="cashout-icon"
                              >
                                <i
                                  _ngcontent-ng-c1546520345=""
                                  className="fa fa-circle"
                                />
                              </span>
                              Cash Out
                            </span>
                          </div>
                          {/**/}
                          {/**/}
                          {/**/}
                        </div>
                      )}
                      <span
                        _ngcontent-ng-c4047091486=""
                        class="matched-count pull-right outer-div4"
                      >
                        Matched{" "}
                        <strong _ngcontent-ng-c4047091486="">€ 1.1K</strong>
                      </span>
                      {/**/}
                      {/**/}
                    </div>
                    <div _ngcontent-ng-c1546520345="" className="card-body p-0">
                      <div
                        _ngcontent-ng-c1546520345=""
                        className="table-responsive position-relative"
                      >
                        <table
                          _ngcontent-ng-c1546520345=""
                          className="table table-hover betfair-tbl tbl-bets p-rltv bookmakerBackground"
                          style={{ marginBottom: 0 }}
                        >
                          <thead
                            _ngcontent-ng-c1546520345=""
                            className="book-maker-table-thead"
                          >
                            <tr>
                              <th
                                _ngcontent-ng-c1546520345=""
                                className="team-name team-width"
                              >
                                {/**/}
                              </th>
                              <th
                                _ngcontent-ng-c1546520345=""
                                colSpan={2}
                                className="mobileTableHead bookmakerbacklay"
                                style={{ textAlign: "right", paddingRight: 20 }}
                              >
                                Back
                              </th>
                              <th
                                _ngcontent-ng-c1546520345=""
                                colSpan={2}
                                className="mobileTableHead bookmakerbacklay"
                                style={{ textAlign: "left", paddingLeft: 20 }}
                              >
                                Lay
                              </th>
                            </tr>
                          </thead>
                          <tbody _ngcontent-ng-c1546520345="">
                            {/**/}
                            {/**/}
                            {odds &&
                              odds.bookMakerOdds &&
                              odds?.bookMakerOdds?.length > 0 &&
                              odds?.bookMakerOdds[0]?.bm1?.oddDetailsDTOS?.map(
                                (item) => (
                                  <>
                                    {item?.status != "ACTIVE" && (
                                      <div
                                        _ngcontent-ng-c1546520345=""
                                        bookmarked_table=""
                                        class="suspend-bookmaker-external unitycss0-7-22-23"
                                      >
                                        <span
                                          _ngcontent-ng-c1546520345=""
                                          bookmarked_table=""
                                          class="stats-text unitycss0-8-23-24"
                                        >
                                          {item?.status}{" "}
                                        </span>
                                      </div>
                                    )}
                                    <tr
                                      _ngcontent-ng-c1546520345=""
                                      className="odd-row"
                                    >
                                      <td
                                        _ngcontent-ng-c1546520345=""
                                        className="team-name team-width bookmakerNameRunner"
                                      >
                                        <span
                                          _ngcontent-ng-c1546520345=""
                                          className="title"
                                        >
                                          {item?.runnerName}
                                        </span>
                                        <span
                                          style={{
                                            display:
                                              eventExposureAndSettings?.plExposureResponseDTOs
                                                ?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    odds?.bookMakerOdds[0]?.bm1
                                                      ?.marketId
                                                )
                                                ?.runnerPlExposureDTOS?.find(
                                                  (runner) =>
                                                    runner.selectionId ==
                                                    item.selectionId
                                                )?.exposure != undefined
                                                ? "flex"
                                                : "none",
                                          }}
                                          _ngcontent-ng-c1703479958=""
                                          className={` ${
                                            eventExposureAndSettings?.plExposureResponseDTOs
                                              ?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  odds?.bookMakerOdds[0]?.bm1
                                                    ?.marketId
                                              )
                                              ?.runnerPlExposureDTOS?.find(
                                                (runner) =>
                                                  runner.selectionId ==
                                                  item.selectionId
                                              )?.exposure < 0
                                              ? "minus-book"
                                              : "plus-book"
                                          } ng-star-inserted`}
                                        >
                                          <i
                                            _ngcontent-ng-c1703479958=""
                                            className="fa fa-arrow-right right-arrow-mt"
                                          />{" "}
                                          &nbsp;{" "}
                                          {
                                            eventExposureAndSettings?.plExposureResponseDTOs
                                              ?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  odds?.bookMakerOdds[0]?.bm1
                                                    ?.marketId
                                              )
                                              ?.runnerPlExposureDTOS?.find(
                                                (runner) =>
                                                  runner.selectionId ==
                                                  item.selectionId
                                              )?.exposure
                                          }
                                        </span>
                                        <span
                                          _ngcontent-ng-c1546520345=""
                                          style={{
                                            display:
                                              selectedEventForBet &&
                                              selectedEventForBet?.marketName ==
                                                odds?.bookMakerOdds[0]?.bm1
                                                  ?.marketName
                                                ? "flex"
                                                : "none",
                                          }}
                                        >
                                          <span
                                            _ngcontent-ng-c1546520345=""
                                            class="d-flex plus-book"
                                            style={{
                                              marginRight: 5,
                                              display: "flex",
                                            }}
                                          >
                                            <span
                                              _ngcontent-ng-c1546520345=""
                                              class={`${
                                               parseFloat(eventExposureAndSettings?.plExposureResponseDTOs
                                              ?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  odds?.bookMakerOdds[0]?.bm1
                                                    ?.marketId
                                              )
                                              ?.runnerPlExposureDTOS?.find(
                                                (runner) =>
                                                  runner.selectionId ==
                                                  item.selectionId
                                              )?.exposure||0)+parseFloat(getPandL(item)) > 0
                                                  ? "plus"
                                                  : "minus"
                                              }-book`}
                                            >
                                              {" "}
                                              &nbsp;({parseFloat(eventExposureAndSettings?.plExposureResponseDTOs
                                              ?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  odds?.bookMakerOdds[0]?.bm1
                                                    ?.marketId
                                              )
                                              ?.runnerPlExposureDTOS?.find(
                                                (runner) =>
                                                  runner.selectionId ==
                                                  item.selectionId
                                              )?.exposure||0)+parseFloat(getPandL(item))})
                                            </span>
                                          </span>
                                        </span>
                                      </td>
                                      <td
                                        _ngcontent-ng-c1546520345=""
                                        style={{ padding: 0 }}
                                      >
                                        <dl
                                          _ngcontent-ng-c1546520345=""
                                          className="back-gradient"
                                        >
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            className={`back_3 count boxHide  ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "back" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.back3
                                                ? "selectBetBack"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="back"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "back3",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.back3)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                                style={{ fontSize: 11 }}
                                              >
                                                {parseInt(item?.backSize3)}
                                              </span>
                                            </a>
                                          </dd>
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            className={`back_2 count boxHide  ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "back" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.back2
                                                ? "selectBetBack"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="back"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "back2",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="back_2 position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.back2)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                                style={{ fontSize: 11 }}
                                              >
                                                {parseInt(item?.backSize2)}
                                              </span>
                                            </a>
                                          </dd>
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            className={`back_1 count  ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "back" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.back1
                                                ? "selectBetBack"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="back"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "back1",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.back1)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                                style={{ fontSize: 11 }}
                                              >
                                                {parseInt(item?.backSize1)}
                                              </span>
                                            </a>
                                          </dd>
                                        </dl>
                                      </td>
                                      <td
                                        _ngcontent-ng-c1546520345=""
                                        colSpan={3}
                                        style={{ padding: 0 }}
                                      >
                                        <dl
                                          _ngcontent-ng-c1546520345=""
                                          className="lay-gradient"
                                        >
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            className={`lay_1 count  ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "lay" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.lay1
                                                ? "selectBetLay"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="lay"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "lay1",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.lay1)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                                style={{ fontSize: 11 }}
                                              >
                                                {parseInt(item?.laySize1)}
                                              </span>
                                            </a>
                                          </dd>
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            className={`lay_2 count boxHide ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "lay" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.lay2
                                                ? "selectBetLay"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="lay"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "lay2",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.lay2)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                              >
                                                {parseInt(item?.laySize2)}
                                              </span>
                                            </a>
                                          </dd>
                                          <dd
                                            _ngcontent-ng-c1546520345=""
                                            id="back_1"
                                            className={`lay_3 count boxHide ${
                                              selectedEventForBet &&
                                              selectedEventForBet.type ==
                                                "lay" &&
                                              selectedEventForBet.selectedId ==
                                                item?.selectionId &&
                                              selectedEventForBet.selectedOdd ==
                                                item?.lay3
                                                ? "selectBetLay"
                                                : ""
                                            }`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <a
                                              _ngcontent-ng-c1546520345=""
                                              appratehighlighter=""
                                              className="lay"
                                              onClick={() => {
                                                bookmakerSetBet(
                                                  item,
                                                  "lay3",
                                                  item?.marketName
                                                );
                                              }}
                                            >
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative match-inn-txt-top"
                                                style={{ fontWeight: 700 }}
                                              >
                                                {parseInt(item?.lay3)}
                                              </span>
                                              <span
                                                _ngcontent-ng-c1546520345=""
                                                className="position-relative"
                                                style={{ fontSize: 11 }}
                                              >
                                                {parseInt(item?.laySize3)}
                                              </span>
                                            </a>
                                          </dd>
                                        </dl>
                                      </td>
                                    </tr>
                                    {selectedEventForBet &&
                                      selectedEventForBet.selectedId ==
                                        item?.selectionId &&
                                      selectedEventForBet.marketName ==
                                        odds?.bookMakerOdds[0]?.bm1
                                          ?.marketName && (
                                        <BetSlip
                                          selectedEventForBet={
                                            selectedEventForBet
                                          }
                                          placeBet={placeBet}
                                          setSelectedEventForBet={
                                            setSelectedEventForBet
                                          }
                                          dispatch={dispatch}
                                        />
                                      )}
                                  </>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
      {/**/}
      {odds?.fancyOdds &&
        odds?.fancyOdds?.length > 0 &&
        odds?.fancyOdds?.find((item) => item?.gameType == "fancy1") && (
          <div
            _ngcontent-ng-c4047091486=""
            className="ipl-winner mt-1 spWinnerMarket ng-star-inserted"
          >
            <div _ngcontent-ng-c4047091486="" className="flex-wrap">
              <div _ngcontent-ng-c4047091486="">
                <div
                  _ngcontent-ng-c4047091486=""
                  className="card mb-0 matchodd bookmaker-mobile-custom-css"
                >
                  <div
                    _ngcontent-ng-c4047091486=""
                    className="card-matchodds outer-divs"
                  >
                    <strong
                      _ngcontent-ng-c4047091486=""
                      className="match-odds bookmaker-dark-head"
                    >
                      Which Team Will Win The Toss{" "}
                      <span
                        _ngcontent-ng-c4047091486=""
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal1"
                        className="marketinfo ml-2"
                      >
                        <svg
                          _ngcontent-ng-c4047091486=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          viewBox="0 0 15 15"
                        >
                          <path
                            _ngcontent-ng-c4047091486=""
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                          />
                        </svg>
                      </span>
                    </strong>
                    <span
                      _ngcontent-ng-c4047091486=""
                      className="matched-count pull-right outer-div4"
                    >
                      Matched{" "}
                      <strong _ngcontent-ng-c4047091486="">€ 10.9K</strong>
                    </span>
                    {/**/}
                  </div>
                  <div
                    _ngcontent-ng-c4047091486=""
                    className="card-body p-0 position-relative"
                  >
                    {/**/}
                    {/**/}
                    <div
                      _ngcontent-ng-c4047091486=""
                      className="position-relative"
                      style={{ overflow: "hidden" }}
                    >
                      <div
                        _ngcontent-ng-c4047091486=""
                        className="row betfair-tbl tbl-bets p-rltv back-gradientSportbook"
                      >
                        {getTossMarket()?.map((item) => (
                          <div
                            onClick={() => {
                              fancySetBet(item, "back1", "fancy1", "fancy1");
                            }}
                            _ngcontent-ng-c4047091486=""
                            className="col-6 ps-1 pe-1 ng-star-inserted"
                          >
                            <div
                              _ngcontent-ng-c4047091486=""
                              className="winMarket position-relative"
                            >
                              {/**/}
                              <div
                                _ngcontent-ng-c4047091486=""
                                className="winTitle"
                              >
                                {item?.runnerName?.split(" ")[0]}
                              </div>
                              <div
                                _ngcontent-ng-c4047091486=""
                                className="sportbook-back"
                                style={{ cursor: "pointer" }}
                              >
                                <a
                                  _ngcontent-ng-c4047091486=""
                                  appratehighlighter=""
                                  className="d-flex flex-column align-items-center justify-content-center"
                                >
                                  <span
                                    _ngcontent-ng-c4047091486=""
                                    className="position-relative match-inn-txt-top"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {item?.back1}
                                  </span>
                                  <span
                                    _ngcontent-ng-c4047091486=""
                                    className="position-relative"
                                    style={{ fontSize: 11 }}
                                  >
                                    {amountFormatter(item?.backSize1)}
                                  </span>
                                </a>
                              </div>
                              {eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                (i) => i.marketIdExternal === item?.marketId
                              ) && (
                                <span _ngcontent-ng-c4047091486="">
                                  <span
                                    _ngcontent-ng-c4047091486=""
                                    className={
                                      eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                        (i) =>
                                          i.marketIdExternal === item?.marketId
                                      )?.exposure > 0
                                        ? "minus-book"
                                        : "plus-book"
                                    }
                                    style={{
                                      display: "block",
                                    }}
                                  >
                                    <i
                                      _ngcontent-ng-c1703479958=""
                                      class="fa fa-arrow-right right-arrow-mt"
                                    ></i>
                                    <span _ngcontent-ng-c4047091486="">
                                      {Math.abs(
                                        eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                          (i) =>
                                            i.marketIdExternal ===
                                            item?.marketId
                                        )?.exposure
                                      ).toFixed(2)}
                                    </span>
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      {/**/}
                      {getTossMarket()?.map(
                        (item) =>
                          selectedEventForBet &&
                          selectedEventForBet.selectedId ==
                            item?.selectionId /*  &&
                          selectedEventForBet?.marketName ==
                            odds?.fancyOdds?.find(
                              (item) =>
                                item?.gameType?.toUpperCase() == selectedFancy
                            )?.marketName */ && (
                            <BetSlip
                              selectedEventForBet={selectedEventForBet}
                              placeBet={placeBet}
                              setSelectedEventForBet={setSelectedEventForBet}
                              isFancy={true}
                              dispatch={dispatch}
                            />
                          )
                      )}
                      <div
                        _ngcontent-ng-c4047091486=""
                        className="row betfair-tbl tbl-bets p-rltv back-gradientSportbook"
                      >
                        {/**/}
                        {/**/}
                        {/**/}
                        {/**/}
                        {/**/}
                      </div>
                      <div _ngcontent-ng-c4047091486="" className="row w-100">
                        {/**/}
                      </div>
                      {/**/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {(selectedMarket?.toLowerCase() == "popular" ||
        selectedMarket?.toLowerCase() == "all") &&
        odds &&
        odds?.fancyOdds &&
        odds?.fancyOdds?.length > 0 && (
          <div
            _ngcontent-ng-c1546520345=""
            className="mobile-query"
            style={{ marginBottom: 70 }}
          >
            <app-market-tabs
              _ngcontent-ng-c1546520345=""
              className="app-market-tabs"
              style={{ width: "100%" }}
              _nghost-ng-c1703479958=""
            >
              <div _ngcontent-ng-c1703479958="" className="card mb-0 noborder">
                <div _ngcontent-ng-c1703479958="" className="p-rltv">
                  <div
                    _ngcontent-ng-c1703479958=""
                    id="fancyBetHeadNew"
                    className="fancy-head"
                  >
                    <h4
                     
                      _ngcontent-ng-c1703479958=""
                    className="in-play"
                    
                    >
                      <span _ngcontent-ng-c1703479958="" id="headerName" onClick={()=>{
                        setSelectedMode("fancy")
                      }}>
                        Fancy Bet
                      </span>
                    <a
                       onClick={() => {
                        setModalContent(<RuleSports />);
                      }}
                        _ngcontent-ng-c1703479958=""
                        className="btn-fancybet_rules"
                      >
                        <svg
                          _ngcontent-ng-c1703479958=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          viewBox="0 0 15 15"
                        >
                          <path
                            _ngcontent-ng-c1703479958=""
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                          />
                        </svg>
                      </a>
                    </h4>
                    <h4
                      _ngcontent-ng-c1703479958=""
                      className="in-play-sportbook"
                    >
                      <span _ngcontent-ng-c1703479958="" id="headerName" onClick={()=>{
                        setSelectedMode("sportsbook")
                      }}>
                        Sportsbook
                      </span>
                      <a
                        _ngcontent-ng-c1703479958=""
                        data-bs-toggle="modal"
                      data-bs-target="#exampleModal2"
                      onClick={()=>{
                        setSportBookModalOpen(true)
                      }}
                        className="btn-sportsbook_rules"
                      >
                        <svg
                          _ngcontent-ng-c1703479958=""
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          viewBox="0 0 15 15"
                        >
                          <path
                            _ngcontent-ng-c1703479958=""
                            fill="currentColor"
                            fillRule="evenodd"
                            d="M6.76 5.246V3.732h1.48v1.514H6.76zm.74 8.276a5.86 5.86 0 0 0 3.029-.83 5.839 5.839 0 0 0 2.163-2.163 5.86 5.86 0 0 0 .83-3.029 5.86 5.86 0 0 0-.83-3.029 5.839 5.839 0 0 0-2.163-2.163 5.86 5.86 0 0 0-3.029-.83 5.86 5.86 0 0 0-3.029.83A5.839 5.839 0 0 0 2.308 4.47a5.86 5.86 0 0 0-.83 3.029 5.86 5.86 0 0 0 .83 3.029 5.839 5.839 0 0 0 2.163 2.163 5.86 5.86 0 0 0 3.029.83zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0zm-.74 11.268V6.761h1.48v4.507H6.76z"
                          />
                        </svg>
                      </a>
                    </h4>
                  </div>
                {
                  selectedMode == "fancy" ?
                  <div
                    _ngcontent-ng-c1703479958=""
                    className="fancy_bet_tab-wrap fancy_bet_back"
                  >
                    <ul
                      _ngcontent-ng-c1703479958=""
                      className="special_bets-tab"
                    >
                      <li
                        onClick={() => {
                          setSelectedFancy("all");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy == "all" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">All</a>
                    </li>
                    <li
                        onClick={() => {
                          setSelectedFancy("fancy1");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy?.toLowerCase() == "fancy1" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">Fancy</a>
                      </li>
                      {odds?.fancyOdds
                        ?.filter(
                          (item) =>
                            item?.gameType?.toUpperCase() != "FANCY1" &&
                            item?.gameType?.toUpperCase() != "ODDEVEN" &&
                            item?.gameType?.toUpperCase() != "NORMAL" &&
                            item?.gameType?.toUpperCase() != "BALL BY BALL" &&
                            item?.gameType?.toUpperCase() != "OVER BY OVER"
                        )
                        .map((item) => (
                          <li
                            onClick={() =>
                              setSelectedFancy(item?.gameType?.toUpperCase())
                            }
                            _ngcontent-ng-c1703479958=""
                            className={
                              selectedFancy == item?.gameType?.toUpperCase() &&
                              "select"
                            }
                          >
                            <a _ngcontent-ng-c1703479958="">
                              {item?.gameType == "fancy1"
                                ? "Fancy"
                                : item?.gameType?.toLowerCase()}
                            </a>
                          </li>
                        ))}
                     
                      <li
                        onClick={() => {
                          setSelectedFancy("LineMarket");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy == "LineMarket" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">Line Market</a>
                    </li>
                    <li
                        onClick={() => {
                          setSelectedFancy("Ball By Ball");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy == "Ball By Ball" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">Ball by Ball</a>
                      </li>
                      <li
                        onClick={() => {
                          setSelectedFancy("Meter");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy == "Meter" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">Meter</a>
                      </li>
                      <li
                        onClick={() => {
                          setSelectedFancy("Khado");
                        }}
                        _ngcontent-ng-c1703479958=""
                        className={selectedFancy == "Khado" && "select"}
                      >
                        <a _ngcontent-ng-c1703479958="">Khado</a>
                      </li>
                    </ul>
                  </div>:<div _ngcontent-ng-c1703479958="" className="fancy_bet_tab-wrap">
  <ul _ngcontent-ng-c1703479958="" className="special_bets-tab bookmakersTabs">
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "all" && "select"} onClick={()=>{
      setSelectedFancy("all")
    }}>
      <a _ngcontent-ng-c1703479958="">All</a>
    </li>
    {/**/}
    {/**/}
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "match" && "select"} onClick={()=>{
      setSelectedFancy("match")
    }}>
      <a _ngcontent-ng-c1703479958="">Match</a>
    </li>
    {/**/}
    {/**/}
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "odds/evens" && "select"} onClick={()=>{
      setSelectedFancy("odds/evens")
    }}>
      <a _ngcontent-ng-c1703479958="">Odds/Evens</a>
    </li>
    {/**/}
    {/**/}
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "batsman" && "select"} onClick={()=>{
      setSelectedFancy("batsman")
    }}>
      <a _ngcontent-ng-c1703479958="">Batsman</a>
    </li>
    {/**/}
    {/**/}
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "bowler" && "select"} onClick={()=>{
      setSelectedFancy("bowler")
    }}>
      <a _ngcontent-ng-c1703479958="">Bowler</a>
    </li>
    {/**/}
    {/**/}
    <li _ngcontent-ng-c1703479958="" className={selectedFancy == "extra" && "select"} onClick={()=>{
      setSelectedFancy("extra")
    }}>
      <a _ngcontent-ng-c1703479958="">Extra</a>
    </li>
    {/**/}
    {/**/}
    {/**/}
  </ul>
</div>
}
                </div>
              </div>
             {selectedMode == "fancy" && <div
                _ngcontent-ng-c1703479958=""
                className="card mb-1 fancy-card"
              >
                <div
                  _ngcontent-ng-c1703479958=""
                  className="card-header card-accrdn card-fancybet"
                />
                <div _ngcontent-ng-c1703479958="" className="card-body p-0">
                  <div
                    _ngcontent-ng-c1703479958=""
                    className="table-responsive"
                  >
                    <div
                      _ngcontent-ng-c1703479958=""
                      className="fency-fency-datatable"
                    >
                      <table
                        _ngcontent-ng-c1703479958=""
                        _ngcontent-twt-c3=""
                        className="table table-hover tbl-bets fancy-bet p-rltv"
                      >
                        {selectedFancy == "Meter" ||
                        selectedFancy == "Khado" ? null : (
                          <thead
                            _ngcontent-ng-c1703479958=""
                            _ngcontent-twt-c3=""
                          >
                            <tr _ngcontent-ng-c1703479958="">
                              <th
                                _ngcontent-ng-c1703479958=""
                                _ngcontent-twt-c3=""
                                colSpan={2}
                                className="minwidth"
                              >
                                <marquee
                                  _ngcontent-ng-c1703479958=""
                                  _ngcontent-twt-c3=""
                                  scrollamount="“3”"
                                  behavior="“scroll”"
                                  direction="scroll"
                                  className="pull-right fancy-marquee"
                                >
                                  <strong
                                    _ngcontent-ng-c1703479958=""
                                    _ngcontent-twt-c3=""
                                  />
                                </marquee>
                              </th>
                              <th
                                _ngcontent-ng-c1703479958=""
                                _ngcontent-twt-c3=""
                                className="lay-1"
                              >
                                {" "}
                                No{" "}
                              </th>
                              {/**/}
                              {/**/}
                              <th
                                _ngcontent-ng-c1703479958=""
                                _ngcontent-twt-c3=""
                                className="back-1"
                              >
                                {" "}
                                Yes{" "}
                              </th>
                              {/**/}
                              {/**/}
                              <th
                                _ngcontent-ng-c1703479958=""
                                _ngcontent-twt-c3=""
                                className="hidden-xs hiddenMobile fancyminmaxText"
                              >
                                {" "}
                                Min/Max{" "}
                              </th>
                            </tr>
                            {/**/}
                          </thead>
                        )}
                        <tbody
                          _ngcontent-ng-c1703479958=""
                          _ngcontent-twt-c3=""
                        >
                          {selectedFancy == "all"
                            ? odds?.fancyOdds?.map((f) =>
                                f?.oddDetailsDTOS
                                  ?.filter(
                                    (item) =>
                                      f?.gameType?.toUpperCase() != "ODDEVEN"
                                  )
                                  ?.map((item) => (
                                    <>
                                      <tr
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        className="odd-row "
                                      >
                                        <td
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          className="team-name valign-middle"
                                        >
                                          <a
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                            onClick={() => {
                                              window.screen.width < 768 &&
                                                setBookModalOpen(item.marketId);
                                            }}
                                            className="title fancy-title"
                                          >
                                            {" "}
                                            {item?.runnerName}{" "}
                                          </a>
                                          <span
                                            style={{
                                              display:
                                                eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    item?.marketId
                                                )?.exposure != undefined
                                                  ? "flex"
                                                  : "none",
                                            }}
                                            _ngcontent-ng-c1703479958=""
                                            className={` ${
                                              item?.runnerName
                                                ?.toLowerCase()
                                                .includes("toss")
                                                ? "plus-book"
                                                : eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                    (i) =>
                                                      i.marketIdExternal ===
                                                      item?.marketId
                                                  )?.exposure < 0
                                                ? "minus-book"
                                                : "plus-book"
                                            } ng-star-inserted`}
                                          >
                                            <i
                                              _ngcontent-ng-c1703479958=""
                                              className="fa fa-arrow-right right-arrow-mt"
                                            />{" "}
                                            &nbsp;{" "}
                                            {item?.runnerName
                                              ?.toLowerCase()
                                              .includes("toss")
                                              ? Math.abs(
                                                  eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                    (i) =>
                                                      i.marketIdExternal ===
                                                      item?.marketId
                                                  )?.exposure
                                                ).toFixed(2)
                                              : eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    item?.marketId
                                                )?.exposure}
                                          </span>
                                        </td>
                                        <td
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          id="style-oONYR"
                                          className="valign-middle mbl-book style-oONYR"
                                        >
                                          <button
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                            onClick={() => {
                                              setBookModalOpen(item.marketId);
                                            }}
                                            className="book-btn btn btn-primary hiddenMobile"
                                          >
                                            {" "}
                                            Book{" "}
                                          </button>
                                          {/**/}
                                          {/**/}
                                          <a
                                            _ngcontent-ng-c1703479958=""
                                            id="btn-fancy_info"
                                            className="btn-fancy_info"
                                          />
                                          {/**/}
                                        </td>
                                        <td
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          id="fancy1012023920102051113"
                                          className={`lay-1 count 1012023920102051113 ${
                                            selectedEventForBet &&
                                            selectedEventForBet.type == "lay" &&
                                            selectedEventForBet.selectedId ==
                                              item?.selectionId
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          <a
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                            onClick={() => {
                                              fancySetBet(
                                                item,
                                                "lay1",
                                                f?.gameType,
                                                f?.gameType
                                              );
                                            }}
                                            id="fancy-odd-p"
                                            appratehighlighter=""
                                          >
                                            <span className="match-inn-txt-top">
                                              <b>
                                                {" "}
                                                {item?.lay1
                                                  ?.toString()
                                                  .includes(".0")
                                                  ? parseFloat(item?.lay1)
                                                  : item?.lay1}
                                              </b>
                                            </span>
                                            <span
                                              _ngcontent-ng-c1703479958=""
                                              _ngcontent-twt-c3=""
                                            >
                                              {parseInt(item?.laySize1)}
                                            </span>
                                          </a>
                                        </td>
                                        <td
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          id="fancy1012023920102051113"
                                          className={`back-1 count p-rltv 1012023920102051113 ${
                                            selectedEventForBet &&
                                            selectedEventForBet.type ==
                                              "back" &&
                                            selectedEventForBet.selectedId ==
                                              item?.selectionId &&
                                            selectedEventForBet.selectedOdd ==
                                              item?.back1
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          {item?.status?.toUpperCase() !=
                                            "ACTIVE" &&
                                            item?.status?.toUpperCase() !=
                                              "" && (
                                              <div
                                                _ngcontent-ng-c1703479958=""
                                                _ngcontent-twt-c3=""
                                                class="spnd-fncy ng-star-inserted"
                                              >
                                                <span
                                                  _ngcontent-ng-c1703479958=""
                                                  _ngcontent-twt-c3=""
                                                  class="stats-text ng-star-inserted"
                                                >
                                                  {" "}
                                                  {item?.status?.toUpperCase()}{" "}
                                                </span>
                                              </div>
                                            )}
                                          <a
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                            appratehighlighter=""
                                            id="fancy-odd-p"
                                            onClick={() => {
                                              fancySetBet(
                                                item,
                                                "back1",
                                                f?.gameType,
                                                f?.gameType
                                              );
                                            }}
                                          >
                                            <span className="match-inn-txt-top">
                                              {item?.back1
                                                ?.toString()
                                                .includes(".0")
                                                ? parseFloat(item?.back1)
                                                : item?.back1}
                                            </span>
                                            <span
                                              _ngcontent-ng-c1703479958=""
                                              _ngcontent-twt-c3=""
                                            >
                                              {item?.backSize1}
                                            </span>
                                          </a>
                                        </td>
                                        <td
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          className="min-max hidden-xs fancyminmaxValue hiddenMobile"
                                        >
                                          {" "}
                                          100 - 25000{" "}
                                        </td>
                                      </tr>
                                      {selectedEventForBet &&
                                        selectedEventForBet.selectedId ==
                                          item?.selectionId &&
                                        selectedEventForBet?.marketName ==
                                          odds?.fancyOdds?.find(
                                            (item) =>
                                              item?.gameType?.toUpperCase() ==
                                              f.gameType?.toUpperCase()
                                          )?.marketName && (
                                          <BetSlip
                                            selectedEventForBet={
                                              selectedEventForBet
                                            }
                                            placeBet={placeBet}
                                            setSelectedEventForBet={
                                              setSelectedEventForBet
                                            }
                                            isFancy={true}
                                            dispatch={dispatch}
                                          />
                                        )}
                                    </>
                                  ))
                              )
                            : odds?.fancyOdds
                                ?.find(
                                  (item) =>
                                    item?.gameType?.toUpperCase() ==
                                    selectedFancy?.toUpperCase()
                                )
                                ?.oddDetailsDTOS?.map((item) => (
                                  <>
                                    <tr
                                      _ngcontent-ng-c1703479958=""
                                      _ngcontent-twt-c3=""
                                      className="odd-row "
                                    >
                                      <td
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        className="team-name valign-middle"
                                      >
                                        <a
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          onClick={() => {
                                            window.screen.width < 768 &&
                                              setBookModalOpen(item.marketId);
                                          }}
                                          className="title fancy-title"
                                        >
                                          {" "}
                                          {item?.runnerName}{" "}
                                        </a>
                                        <span
                                          style={{
                                            display:
                                              eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  item?.marketId
                                              )?.exposure != undefined
                                                ? "flex"
                                                : "none",
                                          }}
                                          _ngcontent-ng-c1703479958=""
                                          className={` ${
                                            item?.runnerName
                                              ?.toLowerCase()
                                              .includes("toss")
                                              ? "plus-book"
                                              : eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    item?.marketId
                                                )?.exposure < 0
                                              ? "minus-book"
                                              : "plus-book"
                                          } ng-star-inserted`}
                                        >
                                          <i
                                            _ngcontent-ng-c1703479958=""
                                            className="fa fa-arrow-right right-arrow-mt"
                                          />{" "}
                                          &nbsp;{" "}
                                          {item?.runnerName
                                            ?.toLowerCase()
                                            .includes("toss")
                                            ? Math.abs(
                                                eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                  (i) =>
                                                    i.marketIdExternal ===
                                                    item?.marketId
                                                )?.exposure
                                              ).toFixed(2)
                                            : eventExposureAndSettings?.plExposureResponseDTOs?.find(
                                                (i) =>
                                                  i.marketIdExternal ===
                                                  item?.marketId
                                              )?.exposure}
                                        </span>
                                      </td>
                                      <td
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        id="style-oONYR"
                                        className="valign-middle mbl-book style-oONYR"
                                      >
                                        <button
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          onClick={() => {
                                            setBookModalOpen(item.marketId);
                                          }}
                                          className="book-btn btn btn-primary hiddenMobile"
                                        >
                                          {" "}
                                          Book{" "}
                                        </button>
                                        {/**/}
                                        {/**/}
                                        <a
                                          _ngcontent-ng-c1703479958=""
                                          id="btn-fancy_info"
                                          className="btn-fancy_info"
                                        />
                                        {/**/}
                                      </td>
                                      <td
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        id="fancy1012023920102051113"
                                        className={`lay-1 count 1012023920102051113 ${
                                          selectedEventForBet &&
                                          selectedEventForBet.type == "lay" &&
                                          selectedEventForBet.selectedId ==
                                            item?.selectionId
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        <a
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          onClick={() => {
                                            fancySetBet(
                                              item,
                                              "lay1",
                                              selectedFancy,
                                              selectedFancy?.toUpperCase()
                                            );
                                          }}
                                          id="fancy-odd-p"
                                          appratehighlighter=""
                                        >
                                          <span className="match-inn-txt-top">
                                            <b>
                                              {" "}
                                              {item?.lay1
                                                ?.toString()
                                                .includes(".0")
                                                ? parseFloat(item?.lay1)
                                                : item?.lay1}
                                            </b>
                                          </span>
                                          <span
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                          >
                                            {item?.laySize1}
                                          </span>
                                        </a>
                                      </td>
                                      <td
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        id="fancy1012023920102051113"
                                        className={`back-1 count p-rltv 1012023920102051113 ${
                                          selectedEventForBet &&
                                          selectedEventForBet.type == "back" &&
                                          selectedEventForBet.selectedId ==
                                            item?.selectionId &&
                                          selectedEventForBet.selectedOdd ==
                                            item?.back1
                                            ? "active"
                                            : ""
                                        }`}
                                      >
                                        {item?.status?.toUpperCase() !=
                                          "ACTIVE" &&
                                          item?.status?.toUpperCase() != "" && (
                                            <div
                                              _ngcontent-ng-c1703479958=""
                                              _ngcontent-twt-c3=""
                                              class="spnd-fncy ng-star-inserted"
                                            >
                                              <span
                                                _ngcontent-ng-c1703479958=""
                                                _ngcontent-twt-c3=""
                                                class="stats-text ng-star-inserted"
                                              >
                                                {" "}
                                                {item?.status?.toUpperCase()}{" "}
                                              </span>
                                            </div>
                                          )}
                                        <a
                                          _ngcontent-ng-c1703479958=""
                                          _ngcontent-twt-c3=""
                                          appratehighlighter=""
                                          id="fancy-odd-p"
                                          onClick={() => {
                                            fancySetBet(
                                              item,
                                              "back1",
                                              selectedFancy,
                                              selectedFancy?.toUpperCase()  
                                            );
                                          }}
                                        >
                                          <span className="match-inn-txt-top">
                                            {item?.back1
                                              ?.toString()
                                              .includes(".0")
                                              ? parseFloat(item?.back1)
                                              : item?.back1}
                                          </span>
                                          <span
                                            _ngcontent-ng-c1703479958=""
                                            _ngcontent-twt-c3=""
                                          >
                                            {item?.backSize1}
                                          </span>
                                        </a>
                                      </td>
                                      <td
                                        _ngcontent-ng-c1703479958=""
                                        _ngcontent-twt-c3=""
                                        className="min-max hidden-xs fancyminmaxValue hiddenMobile"
                                      >
                                        {" "}
                                        100 - 25000{" "}
                                      </td>
                                    </tr>
                                    {selectedEventForBet &&
                                      selectedEventForBet.selectedId ==
                                        item?.selectionId &&
                                      selectedEventForBet?.marketName ==
                                        odds?.fancyOdds?.find(
                                          (item) =>
                                            item?.gameType?.toUpperCase() ==
                                            selectedFancy?.toUpperCase()
                                        )?.marketName && (
                                        <BetSlip
                                          selectedEventForBet={
                                            selectedEventForBet
                                          }
                                          placeBet={placeBet}
                                          setSelectedEventForBet={
                                            setSelectedEventForBet
                                          }
                                          isFancy={true}
                                          dispatch={dispatch}
                                        />
                                      )}
                                  </>
                                ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>}
              {/**/}
              {/**/}
              <div
                _ngcontent-ng-c1703479958=""
                id="Market"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c1703479958=""
                  role="document"
                  className="modal-dialog modal-dialog-centered"
                >
                  <div _ngcontent-ng-c1703479958="" className="modal-content">
                    <div _ngcontent-ng-c1703479958="" className="modal-content">
                      <div
                        _ngcontent-ng-c1703479958=""
                        className="login-popup-content"
                      >
                        <button
                          _ngcontent-ng-c1703479958=""
                          type="button"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          className="close"
                        >
                          <span _ngcontent-ng-c1703479958="" aria-hidden="true">
                            ×
                          </span>
                        </button>
                        <div
                          _ngcontent-ng-c1703479958=""
                          className="login-panel-container confirm-container"
                        >
                          <div
                            _ngcontent-ng-c1703479958=""
                            className="confirm-text"
                          >
                            <div
                              _ngcontent-ng-c1703479958=""
                              className="text1 text-confirm-bold"
                            >
                              Non-Gambling Territories.
                            </div>
                            <hr
                              _ngcontent-ng-c1703479958=""
                              className="confirm-line"
                            />
                            <div _ngcontent-ng-c1703479958="" className="text2">
                              Connecting to our site from non gambling
                              countries, it will be User's responsibility to
                              ensure that their use of the service is lawful.{" "}
                            </div>
                          </div>
                          <div
                            _ngcontent-ng-c1703479958=""
                            className="confirm-text"
                          >
                            <div
                              _ngcontent-ng-c1703479958=""
                              className="text1 text-confirm-bold"
                            >
                              Underage gambling is prohibited.{" "}
                            </div>
                            <hr
                              _ngcontent-ng-c1703479958=""
                              className="confirm-line"
                            />
                            <div _ngcontent-ng-c1703479958="" className="text2">
                              Please confirm if you are{" "}
                              <span
                                _ngcontent-ng-c1703479958=""
                                className="text-confirm-bold"
                              >
                                18 years old and above
                              </span>{" "}
                              as of today.
                            </div>
                          </div>
                          <div
                            _ngcontent-ng-c1703479958=""
                            className="confirm-button"
                          >
                            <button
                              _ngcontent-ng-c1703479958=""
                              className="btn-verification btn-confirm"
                            >
                              <span _ngcontent-ng-c1703479958="">Confirm</span>
                            </button>
                            <button
                              _ngcontent-ng-c1703479958=""
                              data-bs-dismiss="modal"
                              className="btn-verification"
                            >
                              <span _ngcontent-ng-c1703479958="">Exit</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                _ngcontent-ng-c1703479958=""
                id="fancyPLModal"
                tabIndex={-1}
                aria-labelledby="fancyPLModalLabel"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c1703479958=""
                  className="modal-dialog modal-sm"
                >
                  <div _ngcontent-ng-c1703479958="" className="modal-content">
                    <div
                      _ngcontent-ng-c1703479958=""
                      className="modal-header bet-slip-head"
                    >
                      <h1
                        _ngcontent-ng-c1703479958=""
                        id="exposureModalLabel"
                        className="modal-title"
                      >
                        Book
                      </h1>
                      <button
                        _ngcontent-ng-c1703479958=""
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="close"
                      >
                        <span _ngcontent-ng-c1703479958="" aria-hidden="true">
                          ×
                        </span>
                      </button>
                    </div>
                    <div
                      _ngcontent-ng-c1703479958=""
                      className="modal-body scrollBodyRule"
                    >
                      <div _ngcontent-ng-c1703479958="" className="book-popup">
                        <table
                          _ngcontent-ng-c1703479958=""
                          className="table table-bordered fancybooktable"
                        >
                          <thead
                            _ngcontent-ng-c1703479958=""
                            className="border fancyhead"
                          >
                            <tr _ngcontent-ng-c1703479958="">
                              <th
                                _ngcontent-ng-c1703479958=""
                                className="border text-center"
                              >
                                Run
                              </th>
                              <th
                                _ngcontent-ng-c1703479958=""
                                className="border text-center"
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          {/**/}
                          <tbody _ngcontent-ng-c1703479958="">
                            <tr _ngcontent-ng-c1703479958="">
                              <td
                                _ngcontent-ng-c1703479958=""
                                colSpan={2}
                                className="no-data-available"
                              >
                                No data!
                              </td>
                            </tr>
                          </tbody>
                          {/**/}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {bookModalOpen && (
                <BookModal
                  setBookModal={setBookModalOpen}
                  data={getLadderForMarket(bookModalOpen)}
                />
              )}
              <div
  _ngcontent-ng-c1703479958=""
  id="exampleModal2"
  tabIndex={-1}
  role="dialog"
  aria-labelledby="exampleModalLabel"
  className="modal fade show"
  aria-modal="true"
  style={{ display:sportBookModalOpen  ? "block" : "none" }}
>
  <div
    _ngcontent-ng-c1703479958=""
    role="document"
    className="modal-dialog modal-md"
  >
    <div _ngcontent-ng-c1703479958="" className="modal-content">
      <div _ngcontent-ng-c1703479958="" className="modal-content rules-wrap">
        <div _ngcontent-ng-c1703479958="" className="rules-content">
          <div _ngcontent-ng-c1703479958="">
            <div>
              <p>
                1.&nbsp;Cricket General :- ➢ If a ball is not bowled during a
                competition, series or match then all bets will be void except
                for those on any market that has been unconditionally determined
                (e.g. in the 'Completed Match' market).
              </p>
              <p>
                2.&nbsp;Cricket General :- If a match is shortened by weather,
                all bets will be settled according to the official result
                (including for limited overs matches, the result determined by
                the Duckworth Lewis method).
              </p>
              <p>
                3.&nbsp;Cricket General :- In the event of a match being decided
                by a bowl-off or toss of the coin, all bets will be void except
                for those on markets that have been unconditionally determined.
              </p>
              <p>
                4.&nbsp;Cricket Test matches :- If a match starts but is later
                abandoned for any reason other than weather (which may include
                but is not limited to: dangerous or unplayable wicket or
                outfield; pitch vandalism; strike or boycott; crowd
                protests/violence; stadium damage; acts of terrorism; and acts
                of God), Betfair reserves the right to void all bets, except for
                those on markets that have been unconditionally determined.
              </p>
              <p>
                5. In case anyone is found using 2 different IDs and logging in
                from same IP his winning in both accounts will be cancelled.
              </p>
              <p>
                6.&nbsp;Cricket Test matches :- If the match is not scheduled to
                be completed within five days after the original scheduled
                completion date, then all bets on markets for this event will be
                void, except for bets on any markets that have been
                unconditionally determined.
              </p>
              <p>
                7.&nbsp;Cricket Limited Over matches :- If a match is declared{" "}
                {"{"}No Result{"}"}, bets will be void on all markets for the
                event except for those markets which have been unconditionally
                determined or where the minimum number of overs have been bowled
                as laid out in the market specific information.
              </p>
              <p>
                8.&nbsp;Cricket Limited Over matches :- In the event of a new
                toss taking place on a scheduled reserve day for a limited overs
                match all bets that were placed after 30 minutes before the
                original scheduled start of play on the first day will be made
                void. This rule relates to all markets except those that have
                been unconditionally determined (e.g. in the win the toss and
                toss combination markets).
              </p>
              <p>
                9.&nbsp;Multiple Bets :- Multiple Bets With Same Time And Same
                User Will Be Voided Immediately.
              </p>
            </div>
            <div>
              <div>
                <h3>Cricket Bookmaker</h3>
              </div>
              <div>&nbsp;</div>
              <table border={1} width="100%">
                <thead>
                  <tr>
                    <th colSpan={2}>
                      <center>BOOKMAKER RATE PATTERN</center>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <center>BETFAIR RATES</center>
                    </th>
                    <th>
                      <center>BOOKMAKER RATE</center>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">1.54</td>
                    <td align="center">54 = 54 PAISA</td>
                  </tr>
                  <tr>
                    <td align="center">1.58</td>
                    <td align="center">58 = 58 PAISA</td>
                  </tr>
                  <tr>
                    <td align="center">2.72</td>
                    <td align="center">172 = 1 RUPEE 72 PAISA</td>
                  </tr>
                  <tr>
                    <td align="center">2.84 </td>
                    <td align="center">184 = 1 RUPEE 84 PAISA</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
              <div>
                <p>
                  1. Due to any reason any team will be getting advantage or
                  disadvantage we are not concerned.
                </p>
              </div>
              <div>
                <p>
                  2. We will simply compare both teams 25 overs score higher
                  score team will be declared winner in ODI (25 over comparison)
                </p>
              </div>
              <div>
                <p>
                  3. We will simply compare both teams 10 overs higher score
                  team will be declared winner in T20 matches (10 over
                  comparison)
                </p>
              </div>
              <div>
                <p>
                  4. Any query about the result or rates should be contacted
                  within 7 days of the specific event, the same will not be
                  considered valid post 7 days from the event.
                </p>
                <p>
                  <strong>➣ Next Man Out/Caught Out</strong>
                </p>
                <p>1.Advance Market wil be Valid in Both Innings</p>
                <p>2.If Player does not Come Then All Bets Will Be Voided.</p>
                <p>
                  3.If Both Player Remain Not Out till Innings end, Then All
                  Bets will be voided.
                </p>
                <p>
                  <strong>➣ Luch Favourite Market</strong>
                </p>
                <p>
                  1.In the innings Break Which Team is Favourite will be
                  Considered as lunch Favourite.
                </p>
                <p>2.If Match gets TIE All bets will be voided.</p>
                <p>
                  3.In case Overs are reduecd in a match, the team wich
                  favourite at the inning break will be considerd as Lunch
                  Favourite.
                </p>
              </div>
              <div className="rules-content">
                <div>
                  <div>
                    <div>
                      <h3>
                        <strong>Rules Of Fancy Bets</strong>
                      </h3>
                    </div>
                  </div>
                  <div>
                    <p>
                      1.Once all session/fancy bets are completed and settled
                      there will be no reversal even if the Match is Tied or is
                      Abandoned.
                    </p>
                    <p>
                      2.All Advance Fancy Bets Market will be Suspended 60 mins
                      prior to Match and will be Settled.
                    </p>
                    <p>
                      3.Under the Rules of Fancy Market if Market Gets Suspended
                      for any reason and does not resume rhen all Previous Bets
                      will remain Valid and become Har-Jeet bets.
                    </p>
                    <p>
                      4. All decisions relating to settlement of wrong market
                      being offered will be taken by management. Management will
                      consider all actual facts and decision taken will be full
                      and final.
                    </p>
                    <p>
                      5.Due to any technical error market is open and result has
                      came all bets after result will be Voided.
                    </p>
                    <p>
                      6. If any case wrong rate has been given in fancy ,that
                      particular bets will be Voided (Wrong Commentary).
                    </p>
                    <p>
                      7.Should there be a power failure or a problem with the
                      Internet Connection at our end and Fancy Market does not
                      get suspended then our decision on the outcome is final.
                    </p>
                    <p>
                      8.In case customer make bets in wrong fancy we are not
                      liable to delete. No changes will be made and bets will be
                      consider as confirm bet.
                    </p>
                    <p>
                      9.In any circumstances management decision will be final
                      related to all exchange items. Our scorecard will be
                      considered as valid if there is any mismatch in online
                      portal.
                    </p>
                    <p>
                      10.Any bets which are deemed of being suspicious,
                      including bets which have been placed from the stadium or
                      from a source at the stadium maybe voided at anytime. The
                      decision of whether to void the particular bet in question
                      or to void the entire market will remain at the discretion
                      of Company. The final decision of whether bets are
                      suspicious will be taken by Company and that decision will
                      be full and final.
                    </p>
                    <p>
                      11.Any sort of cheating bet , any sort of Matching
                      (Passing of funds), Court Siding (Ghaobaazi on
                      commentary), Sharpening, Commission making is not allowed
                      in Company, If any company User is caught in any of such
                      act then all the funds belonging that account would be
                      seized and confiscated. No argument or claim in that
                      context would be entertained and the decision made by
                      company management will stand as final authority.
                    </p>
                    <p>
                      12.Fluke hunting/Seeking is prohibited in Company , All
                      the fluke bets will be reversed. Cricket Commentary and
                      Live Streaming is just an additional feature and facility
                      for company user but company is not responsible for any
                      delay or mistake in Commentary and Live Streaming.
                    </p>
                    <p>
                      13.Penalty Runs - Any Penalty Runs in the Match Will be
                      Counted While Settling in our Exchange.
                    </p>
                    <p>
                      <strong>➣ Test Match Fancy Rules</strong>
                    </p>
                    <p>
                      <b>1. Session Market (Test Match)</b>
                    </p>
                    <p>1.1 Complete session valid in test.</p>
                    <p>
                      1.2 In Case of team all out, running session will be
                      settled at current score
                    </p>
                    <p>
                      1.3 Due to Innings Declaration or Team all out, middle
                      session and session is not completed so that particular
                      over is considerd complited and remaining over will bet
                      counted in next inning. For Example:-
                    </p>
                    <ul>
                      <li>
                        You are Placing Advance Bets in 1st innigs 80 over runs
                        ADV in case team-A declares or all-out at 70 over next
                        10 over counted in Team-B's 1st inning
                      </li>
                      <li>
                        Current over is 70.4 and 75 Over Session is Running and
                        Inning Has been Declared or All out, Following Condition
                        Will be Applied
                        <br />
                        <ul>
                          <li>Over Will Be Rounded 71.</li>
                          <li>
                            Remaining 4 Over Will Be Counted From Next Inning.
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p>
                      1.4 Test match both advance session is valid on Both
                      Team's 1st Innings.
                    </p>
                    <p>
                      1.5 1st day 1st session Runs minimum 25 over will be
                      played then result will given otherwise 1st day 1st
                      session will be Voided.
                    </p>
                    <p>
                      1.6 1st day 2nd session Runs minimum Total 50 over will be
                      played then result will given otherwise 1st day 2nd
                      session Runs will be Voided.
                    </p>
                    <p>
                      1.7 1st Day Total Runs minimum total 80 over will be
                      played then result will given otherwise 1st day total Runs
                      will be Voided.
                    </p>
                    <p>
                      <b>2. Lambi Market/Inning Runs (Test Match)</b>
                    </p>
                    <p>
                      2.1 If Any Team Announce Declaration or All Out Then Lambi
                      Market/Inning Runs Will Be Valid
                    </p>
                    <p>
                      2.2 Team Has to Play Mandotary 70 Over For Lambi
                      Market/Inning Runs
                    </p>
                    <p>
                      2.3 In case due to weather situation match has been
                      stopped all lambi trades will be Voided
                    </p>
                    <p>
                      2.4 both advance Lambi Market/Inning Runs is valid on Both
                      Team's 1st Innings.
                    </p>
                    <p>
                      <strong>3. 1 Over Session Market (Test Match)</strong>
                    </p>
                    <p>
                      3.1 Match 1st over run advance fancy only 1st innings run
                      will be counted
                    </p>
                    <p>
                      3.2 Due to Innings Declaration Following Condition Will Be
                      Applied.
                      <br />
                      <br />
                      <i>For Example</i>:- Current over is 70.4 and 71 Over
                      Session Runs is Running and Score is 180/4 (70.4 Over)and
                      Inning Has been Declared 71 Over Session Runs Will Be
                      Voided.
                    </p>
                    <p>
                      3.3 Due to Innings All Out Following Condition Will Be
                      Applied.
                      <br />
                      <br /> <i>For Example</i>:- Current Over is 55.3 and 56
                      Over Runs is Running and Score is 111/10 Then Result Of 56
                      Over Runs will be 111 Runs.
                    </p>
                    <p>
                      3.4 In Case of Weather Will Affected Between Match and
                      result will be given.
                      <br />
                      <br />
                      <i>For Example</i> :- Current over is 70.4 and 71 Over
                      Session Runs is Running and Score is 180/4 (70.4 Over)and
                      Weather will Affected match then 71 Over Session Runs Will
                      Be Voided.
                    </p>
                    <p>
                      <strong>4. Only Over Session Market (Test Match)</strong>
                    </p>
                    <p>
                      4.1 Due to Innings Declaration/All Out/Weather Situation
                      Running Only Over Session Will Be settled
                    </p>
                    For Example:-
                    <ul>
                      <li>
                        55.1 Over has been played and innning ends then 56th
                        only Over Runs Will Be settled
                      </li>
                      <li>
                        55 Over has been played and innning ends then 56th only
                        Over Runs Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      <strong>5. Fall of Wicket Market (Test Match)</strong>
                    </p>
                    <p>
                      5.1 In Fall of Wicket Market one Batsman is Injured Or
                      Retired Out Then Market Will Be Continue with Next
                      Batsman.
                    </p>
                    <p>
                      5.2 In Case Due to Weather Condition or Declaration of
                      Inning, Market Result will Be Given As Per Score.
                    </p>
                    <p>
                      5.3 Advance Market is Valid In Case Both Player Diffrent
                      or Same.
                    </p>
                    <p>
                      5.4 Advance Market is valid on Both Team's 1st Innings.
                    </p>
                    <p>
                      <strong>
                        6. Wicket Partnership Boundaries (Test Match )
                      </strong>
                    </p>
                    <p>
                      6.1 In Fall of Wicket Market one Batsman is Injured Or
                      Retired Out Then Market Will Be Continue with Next
                      Batsman.
                    </p>
                    <p>
                      6.2 In Case Due to Weather Condition or Declaration of
                      Inning, Market Result will Be Given As Per Score.
                    </p>
                    <p>
                      6.3 Advance Market is Valid In Case Both Player Diffrent
                      or Same.
                    </p>
                    <p>
                      6.4 Advance Market is valid on Both Team's 1st Innings.
                    </p>
                    <p>
                      <strong>7. Player/Batsman Market (Test Match)</strong>
                    </p>
                    <p>
                      7.1 In case Player is injured he/she has made 18 runs the
                      market will be settled at 18 Runs
                    </p>
                    <p>
                      7.2 Player 50/100 run market will be settled at current
                      Player runs if batsman is injured, inning has been
                      declared or team is all out.
                    </p>
                    <p>
                      7.3 In Advance Market If Same Player Will Came in The
                      Opening Then Market Will be Valid Otherwise It will be
                      Voided.
                    </p>
                    <p>
                      7.4 Advance Market is valid on Both Team's 1st Innings.
                    </p>
                    <p>
                      <strong>
                        8. Player/Batsman Boundaries Market (Test Match)
                      </strong>
                    </p>
                    <p>
                      8.1 In case Player is injured he/she has made 2 Boundaries
                      the market will be settled at 2 Boundaries.
                    </p>
                    <p>
                      8.2 In Advance Market If Same Player Will Came in The
                      Opening Then Market Will be Valid Otherwise It will be
                      Voided.
                    </p>
                    <p>
                      8.3 Advance Market is valid on Both Team's 1st Innings.
                    </p>
                    <p>
                      <strong>9. Advance Special Market</strong>
                    </p>
                    <p>
                      9.1 TOTAL MATCH FOURS,SIXES,WIDES, WICKETS, EXTRA RUNS,
                      TOTAL RUNS, HIGEST OVER, PARTNERSHIP and TOP BATSMAN RUNS
                      is valid only if 300 overs has been played or the match
                      has been won by any team otherwise all these fancy will be
                      Voided. Additionally all events are valid only for 1st
                      innings.
                    </p>
                    <p>
                      <strong>➣ ONE DAY/T20/T10 Match FANCY RULES</strong>
                    </p>
                    <p>
                      <strong>1. Session Market (One Day/T20/T10 Match)</strong>
                    </p>
                    <p>1.1 Advance Session is Valid only 1st Innings.</p>
                    <p />
                    1.2 In Case of Running Match Getting Cancelled/No
                    Result/Abandoned but the Session is complete it will be
                    settle.
                    <p />
                    &nbsp;<i>For Example</i>:-
                    <ul>
                      <li>
                        Current over is 20.4 and 25 Over Session Runs is Running
                        and Score is 180/4 (20.4 Over)and Match Cancelled/No
                        Result/Abonded will Affected match then 25 Over Session
                        Runs Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        2. 1 Over Session Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      2.1 Match 1st over run advance fancy only 1st innings run
                      will be counted
                    </p>
                    <p>
                      2.2 Due to Innings All Out Following Condition Will Be
                      Applied For Example:- Current Over is 45.3 and 46 Over
                      Runs is Running and Score is 111/10 Then Result Of 46 Over
                      Runs will be 111 Runs.
                    </p>
                    <p>
                      2.3 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned but the Market is complete it will be
                      settle
                    </p>
                    <i>For Example</i> :-
                    <ul>
                      <li>
                        Current over is 45.3 and 46 Over Session Runs is Running
                        and Score is 180/4 (45.3 Over) then 46 Over Session Runs
                        Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        3. Only Over/ Session Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      3.1 Due to Innings Declaration/All Out/Weather Situation
                      Running Only Over Session Will Be settled
                    </p>
                    <i>For Example:-</i>
                    <ul>
                      <li>
                        55.1 Over has been played and innning ends then 56th
                        only Over Runs Will Be settled.
                      </li>
                      <li>
                        55 Over has been played and innning ends then 56th only
                        Over Runs Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        4. Fall of Wicket Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      4.1 In Fall of Wicket Market one Batsman is Injured Or
                      Retired Out Then Market Will Be Continue with Next
                      Batsman.
                    </p>
                    <p>
                      4.2 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned, Market Result will Be Given As Per
                      Score.
                      <br />
                      Note:-After Bet Minimum 1 Ball to Bowl Other wise that
                      Particular Bet Will Be Voided.
                    </p>
                    <p>
                      4.3 Advance Market is Valid In Case Both Player Diffrent
                      or Same.
                    </p>
                    <p>
                      4.4 Both Team Advance Market Valid in Particular Match.
                      <br />
                      Note:- Fall of 2nd wicket ADV and Fall Of 3rd Wicket Adv
                      Will be Voided in 2nd innings
                    </p>
                    <p>
                      <strong>
                        5. Wicket Partnership Boundaries (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      5.1 In Fall of Wicket Market one Batsman is Injured Or
                      Retired Out Then Market Will Be Continue with Next
                      Batsman.
                    </p>
                    <p>
                      5.2 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned, Market Result will Be Given As Per
                      Score.
                      <br />
                      Note:-After Bet Minimum 1 Ball to Bowl Other wise that
                      Particular Bet Will Be Voided.
                    </p>
                    <p>
                      5.3 Advance Market is Valid In Case Both Player Diffrent
                      or Same.
                    </p>
                    <p>
                      5.4 Both Team Advance Market Valid in Particular Match.
                    </p>
                    <p>
                      <strong>
                        6. Player/Batsman Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      6.1 In case Player is injured he/she has made 18 runs the
                      market will be settled at 18 Runs
                    </p>
                    <p>
                      6.2 In Advance Market If Same Player Will Came in The
                      Opening Then Market Will be Valid Otherwise It will be
                      Voided.
                    </p>
                    <p>6.3 Advance Market is valid on Both Innings.</p>
                    <p>
                      6.4 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned, Market Result will Be Given As Per
                      Score. Note:-After Bet Minimum 1 Ball to Bowl Other wise
                      that Particular Bet Will Be Voided.
                    </p>
                    <p>
                      <strong>
                        7. Player/Batsman Boundaries Market (One Day/T20/T10
                        Match)
                      </strong>
                    </p>
                    <p>
                      7.1 In case Player is injured he/she has made 2 Boundaries
                      the market will be settled at 2 Boundaries.
                    </p>
                    <p>
                      7.2 In Advance Market If Same Player Will Came in The
                      Opening Then Market Will be Valid Otherwise It will be
                      Voided.
                    </p>
                    <p>7.3 Advance Market is valid on Both Innings.</p>
                    <p>
                      7.4 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned, Market Result will Be Given As Per
                      Score.
                      <br />
                      Note:-After Bet Minimum 1 Ball to Bowl Other wise that
                      Particular Bet Will Be Voided.
                    </p>
                    <p>
                      <strong>
                        8. Only Over Boundary Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      8.1 Due to Innings Declaration/All Out/Weather Situation
                      Running Only Over Boundary Market Will Be settled
                    </p>
                    <br />
                    <i>For Example</i>:-
                    <ul>
                      <li>
                        55.1 Over has been played and innning ends then 56th
                        only Over Runs Will Be settled
                      </li>
                      <li>
                        55 Over has been played and innning ends then 56th only
                        Over Runs Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      8.2 Runs Comes In Boundary Format (4's and 6's) Will be
                      Counted in This Market,{" "}
                    </p>
                    <p></p>
                    <ul>
                      <li>
                        Leg Bye Boundaries,Bye Boundaries,No Ball
                        Boundaries,Wide Boundaries,Over Throw Boundaries all Are
                        Counted in this Market.
                      </li>
                      <li>
                        For Boundary Count Ball Must Be Corssed Boundary line
                        For Validation.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        9. Only Over Dot Ball Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      9.1 Due to Innings Declaration/All Out/Weather Situation
                      Running Only Over Boundary Market Will Be settled
                    </p>
                    <i>For Example</i>:-
                    <ul>
                      <li>
                        55.1 Over has been played and innning ends then 56th
                        only Over Runs Will Be settled.
                      </li>
                      <li>
                        55 Over has been played and innning ends then 56th only
                        Over Runs Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      9.2 Only No Run will Be Counted a Dot Ball in this Market
                    </p>
                    <ul>
                      <li>Dot Ball :- Counted as A Dot Ball </li>
                      <li>Wide Ball :- Not Counted as a Dot Ball</li>
                      <li>No Ball :- Not Counted as a Dot Ball</li>
                      <li>Leg Bye Runs :- Not Counted as a Dot Ball</li>
                      <li>Bye Runs :- Not Counted as a Dot Ball</li>
                      <li>
                        Wicket :- Any Format of Wicket Will be Not Counted as a
                        Dot Ball{" "}
                      </li>
                    </ul>
                    <p>
                      <strong>
                        10. Wicket Lost to Balls/ How Many Balls Face By Player
                        Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      10.1 In case Player is injured he/she Played 22 Balls the
                      market will be settled at 22 Balls.
                    </p>
                    <p>
                      10.2 In Advance Market If Same Player Will Came in The
                      Opening Then Market Will be Valid Otherwise It will be
                      Voided.
                    </p>
                    <p>10.3 Advance Market is valid on Both Innings.</p>
                    <p>
                      10.4 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned, Market Result will Be Given As Per
                      Score.
                      <br />
                      Note:-After Bet Minimum 1 Ball to Bowl Other wise that
                      Particular Bet Will Be Voided.
                    </p>
                    <p>
                      <strong>
                        11. Ball By Ball Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      11.1 After Bet Minimum 1 Ball to Bowl Other wise that
                      Particular Bet Will Be Voided.
                    </p>
                    <p>
                      <strong>
                        13. Bowler Session Market (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      13.1 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned but the Session is complete it will be
                      settle.
                    </p>
                    <i>For Example</i>:-
                    <ul>
                      <li>
                        Player X Bowling his 4th over and Player X's 5 Over
                        Session Runs is Running and Match Cancelled/No
                        Result/Abonded will Affected match then Player X's 5
                        Over Session Runs Will Be Voided.
                      </li>
                      <li>
                        After Bet Minimum 1 Ball to Bowl Other wise that
                        Particular Bet Will Be Voided.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        12. Advance Special Markets (One Day/T20/T10 Match)
                      </strong>
                    </p>
                    <p>
                      12.1 TOTAL MATCH FOURS,SIXES,WIDES, WICKETS, EXTRA RUNS,
                      TOTAL RUNS, HIGEST OVER, PARTNERSHIP and TOP BATSMAN RUNS
                      is valid only if Total Match Will be Played or the match
                      has been won by any team, Otherwise All bets will Be
                      Voided.
                    </p>
                    <p>
                      12.2 In Case of Running Match Getting Cancelled/No
                      Result/Abandoned/Over Reduce, Markets Will Be Voided.
                    </p>
                  </div>
                  <div>
                    <div>
                      <h3>
                        <strong>Rules Of Line Market</strong>
                      </h3>
                    </div>
                  </div>
                  <div>
                    <div>
                      <p>
                        1.How many runs will be scored in the stated number of
                        overs? Line market: This market operate with a bet delay
                        of 1 second; All bets are struck at 2.0 The 'price' at
                        which your bet is placed defines the number of runs bet
                        upon. *YES Line* (buy) bets win when more runs are
                        scored in the specified number of overs than the 'price'
                        at which the bet is matched. *NO Line* (Sell) bets win
                        when fewer runs are scored in the specified number of
                        overs than the 'price' at which the bet is matched. This
                        market will be settled if 5 overs have been completed in
                        the innings, the batting team is bowled out or has
                        reached the target to win the match.
                      </p>
                      <p>
                        2. How many runs will be scored in the stated number of
                        overs? Line market:This market operate with a bet delay
                        of 1 second; All bets are struck at 2.0 . The 'price' at
                        which your bet is placed defines the number of runs bet
                        upon. *YES Line* (Buy) bets win when more runs are
                        scored in the specified number of overs than the 'price'
                        at which the bet is matched. *NO Line* (Sell) bets win
                        when fewer runs are scored in the specified number of
                        overs than the 'price' at which the bet is matched.
                        Special rules for Overs Runs Line markets: Bets will be
                        void - regardless of whether the outcome of the bet is
                        already unconditionally determined - when any of the
                        following are the case: -if the scheduled number of
                        overs for the innings is reduced by rain interruption
                        and, at settlement time, the actual number of overs
                        bowled is less than the number of overs stipulated at
                        the head of these rules. - if the scheduled number of
                        overs for the innings is reduced for any other reason
                        after the innings has begun and at settlement time, that
                        new number of scheduled overs is less than the number of
                        overs stipulated at the head of these rules. Please note
                        if the batting side reach their target within the 20
                        overs or have been bowled out and the innings hasn’t
                        been reduced in overs to less than the stipulated number
                        at the head of the rules, the market will be settled.
                      </p>
                      <div>
                        <div></div>
                      </div>
                      <div>
                        <div>
                          <div>
                            <div>
                              <h3>
                                <strong>
                                  ➣ Sportsbook Market Rules (Test/One
                                  Day/T20/T10 Match)
                                </strong>
                              </h3>
                            </div>
                          </div>
                          <p>
                            <strong>1. Odd Even Markets</strong>
                          </p>
                          <p>
                            1.1 In Case of Running Match Getting
                            Completed/Cancelled/No Result/Abandoned but the
                            Market is complete it will be settle.
                          </p>
                          <i>For Example</i>:-Current over is 20.4 and 25 Over
                          Odd/Even Market is Running and Score is 180/4 (20.4
                          Over)and Match Completed/Cancelled/No Result/All
                          Out/Abonded will Affected match then 25 Over Odd/Even
                          Market Will Be Voided.
                          <p>
                            1.2 After Bet Minimum 1 Ball to Bowl Other wise that
                            Particular Bet Will Be Voided.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div>
                            <div>
                              <p>
                                <strong>
                                  2. Last Digit Market (Test/One Day/T20/T10
                                  Match)
                                </strong>
                              </p>
                            </div>
                          </div>
                          <p>
                            1. In Case of Running Match Getting Cancelled/No
                            Result/Abandoned but the Market is complete it will
                            be settle.
                          </p>
                          <i>For Example</i>:-
                          <br />
                          Current over is 20.4 and 25 Over Last Digit Market is
                          Running and Score is 180/4 (20.4 Over)and Match
                          Completed/Cancelled/No Result/All Out/Abonded will
                          Affected match then 25 Over Lasr Digit Market Will Be
                          Voided.
                        </div>
                      </div>
                      <div>
                        <div>
                          <div>
                            <div>
                              <p>
                                <strong>3. Advance Special Markets</strong>
                              </p>
                            </div>
                          </div>
                          <p>
                            3.1 In Case of Running Match Getting Cancelled/No
                            Result/Abandoned but the Market is complete it will
                            be settle
                          </p>
                        </div>
                      </div>
                      <div>
                        <div>
                          <p>
                            <strong>4. Meter Market </strong>
                          </p>
                        </div>
                      </div>
                      <p>
                        4.1.In Case of Running Match Getting Cancelled/No
                        Result/Abandoned Resut Will Be Given at Mid Point of
                        Current Value.
                      </p>
                      <ul>
                        <li>
                          If Meter Market's Current value is 75/77 or 75/76 then
                          result will be 76 respectively.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div>
                      <p>
                        <strong>5. Khado Market </strong>
                      </p>
                    </div>
                  </div>
                  <p>1. Advance Khado Market is Valid Only 1st Innings</p>
                  <p>
                    2. In Case of Running Match Getting Cancelled/No
                    Result/Abandoned but the Market is complete it will be
                    settle.
                  </p>
                  <p>3. You Have to Chose Your Own Value in This Market.</p>
                </div>
              </div>
              <div>
                <div>
                  <p>
                    <strong>Indian Premier League (IPL) </strong>
                  </p>
                </div>
              </div>
              <p>
                1. If IPL fixture of 74 matches gets reduced due to any reason,
                then all the special fancies will be voided (Match abandoned due
                to rain/bad light will not be considered in this).
              </p>
              <p>
                2.At any situation if result is given for any particular event
                based on the rates given for the same, then the particular
                result will be considered valid, similarly if the tournament
                gets canceled due to any reason the previously given result will
                be considered valid.
              </p>
              <p>3.Management decision will be final.</p>
              <p>4.Highest innings run - Only First innings is valid.</p>
              <p>5.Lowest innings run - Only First innings is valid.</p>
              <p>6.Highest Partnership Runs in IPL: Both Innings are valid.</p>
              <p>
                7.Highest Run Scorer : Total Runs Scored by An Individual
                Batsman in Full Tournament.
              </p>
              <p>
                8.Highest Wicket Taker : Total Wickets Taken by a Bowler in Full
                Tournament.
              </p>
              <p>
                9.How Many time 5 or More Wickets taken by Bowlers : Number of
                time 5 or More Wickets taken by Bowlers. In Case Same Bowler 2
                time 5 or More Wickets taken means Result Counted as 2.
              </p>
              <p>
                10.Total 4's: Average 29 Fours will be given in case match
                abandoned or over reduced.
              </p>
              <p>
                11.Total 6's: Average 16 Sixes will be given in case match
                abandoned or over reduced.
              </p>
              <p>
                12.Total 30's: Average 2 Thirties will be given in case match
                abandoned or over reduced
              </p>
              <p>
                13.Total 50's: Average 2 Fifties will be given in case match
                abandoned or over reduced
              </p>
              <p>
                14.Total No balls:- Average 1 No ball will be given in case
                match abandoned or over reduced
              </p>
              <p>
                15.Total Wickets - Average will 12 Wickets be given in case
                match abandoned or over reduced
              </p>
              <p>
                16.Total Wides - Average 11 Wides will be given in case match
                abandoned or over reduced
              </p>
              <p>
                17.Total Extras - Average 18 Extras will be given in case match
                abandoned or over reduced
              </p>
              <p>
                18.Total Caught outs: Average 9 Caught out will be given in case
                match abandoned or over reduced
              </p>
              <p>
                19.Total Bowled:- Average 2 Bowled out will be given in case
                match abandoned or over reduced
              </p>
              <p>
                20.Total LBW:- Average 1 LBW will be given in case match
                abandoned or over reduced
              </p>
              <p>
                21.Total Run out:- Average 1 Run out will be given in case match
                abandoned or over reduced
              </p>
              <p>
                22.Total Duckouts in IPL : Average 1 Duckout will be given in
                case match abandoned or over reduced
              </p>
              <p>
                23.Total 50+ Partnerships - Average 2 Fifty plus Partnerships
                will be given in case match abandoned or over reduced. 50 and 50
                Above Partnerships All Counted in this.
              </p>
              <p>
                24.Total Highest Scoring Over Runs in IPL: Total of Every Match
                Highest Scoring Over Runs. Average 20 Runs will be given in case
                match abandoned or over reduced.
              </p>
              <p>
                25.Total Runs Scored in IPL : Total Runs Scored in Full
                Tournament. Average 350 Runs will be Counted in case match
                abandoned or over reduced. Both Innings Counted.
              </p>
              <p>
                26.Highest Match 1st Over Run of IPL :Only First Innings is
                Valid.
              </p>
              <p>
                27.Highest 1st 6 over run: Only First Innings is Valid. Will not
                consider if over reduce before completion 6 over.
              </p>
              <p>
                28.Highest 1st 10 over run : Only First Innings is Valid. Will
                not consider if over reduce before completion 10 over.
              </p>
              <p>
                29.Highest 4s,6s,30s,50s Single Digit Scorers, Double Digit
                Scorers,Wickets,Caught Outs,Bowled,Lbw, Runouts, Stumpings,
                Duckouts,Wides and Extras in individual match: All Both innings
                are Counted.
              </p>
              <p>30.Highest Scoring Over Runs in IPL: Both innings are valid</p>
              <p>
                31.Single Digit Scorers : Duck outs Not Considered in this
                Event. If Not out Batsman/Injured Batsman facing One Legal
                Delivery and nothing scored ('0') means Considered as Single
                Digit
              </p>
              <p>
                32.Most 6's by individual batsman of IPL : Maximum Number of
                Sixes Hit By A Batsman in full Tournament. Ex. Last Season
                (2021) KL Rahul Hit 30 Sixes in 13 Matches. So, 30 was the
                Result for last season.
              </p>
              <p>
                33.Most Balls Faced By a Batsman of IPL : Maximum balls Faced by
                an Individual Batsman in the Single Match.
              </p>
              <p>
                34.Most runs given by Bowler in an Inning of IPL : Maximum Runs
                conceded by a individual Bowler in an Innings.
              </p>
              <p>
                35.Most Wide, Noball,Extras,4s,6s,30s,50s,50+ Pships,Caught
                Outs,LBWs, Runouts and Duckouts in an Innings Of the Match :
                Considered For Any Innings.All Both Innings Considered as Valid
              </p>
            </div>
            <div>
              <div>
                <p>
                  <strong>Pakistan Super League (PSL) </strong>
                </p>
                <p>
                  1. If PSL fixture of 34 matches gets reduced due to any
                  reason, then all the special fancies will be voided (Match
                  abandoned due to rain/bad light will not be considered in
                  this)
                </p>
                <p>
                  2. Total Matches 1st over runs : Average 6 runs will be given
                  in case match abandoned or over reduced (only 1st innings
                  valid).
                </p>
                <p>
                  3. Total Matches 1st 6 over runs : Average 50 runs will be
                  given in case match abandoned or over reduced (Only 1st
                  Innings valid)
                </p>
                <p>
                  4. Total fours: Average 32 fours will be given in case match
                  abandoned or over reduced.
                </p>
                <p>
                  5.Total sixes: Average 13 sixes will be given in case match
                  abandoned or over reduced
                </p>
                <p>
                  6.Total 30's: Average 2 Thirties will be given in case match
                  abandoned or over reduced
                </p>
                <p>
                  7.Total Fifties - Average 2 Fifties will be given in case
                  match abandoned or over reduced
                </p>
                <p>
                  8.Total Wickets - Average 13 Wickets will be given in case
                  match abandoned or over reduced
                </p>
                <p>
                  9.Total Wides - Average 11 Wides will be given in case match
                  abandoned or over reduced
                </p>
                <p>
                  10.Total Extras - Average 18 Extras will be given in case
                  match abandoned or over reduced
                </p>
                <p>
                  11.Total Caught outs: Average 8 Caught out will be given in
                  case match abandoned or over reduced
                </p>
                <p>
                  12.Total Bowled:- Average 2 Bowled out will be given in case
                  match abandoned or over reduced
                </p>
                <p>
                  13.Total LBW:- Average 1 LBW will be given in case match
                  abandoned or over reduced
                </p>
                <p>
                  14.Total Run out:- Average 1 Run out will be given in case
                  match abandoned or over reduced
                </p>
              </div>
            </div>
          </div>
        </div>
        <ul _ngcontent-ng-c1703479958="" className="btn-wrap break">
          <li _ngcontent-ng-c1703479958="" style={{ listStyle: "none" }}>
            <a
              _ngcontent-ng-c1703479958=""
              onClick={()=>{
                setSportBookModalOpen(false)
              }}
              className="btnok"
            >
              OK
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

            </app-market-tabs>
            {/**/}
          </div>
        )}
      {/**/}
      {modalContent && (
        <Modal content={modalContent} setShowModal={setModalContent} />
      )}
    </app-market-details>
  );
}
